var _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "583.44 433.77 583.44 464.19 627.91 464.19 676.97 464.19 676.97 433.77 583.44 433.77",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "579.51 425.27 579.51 433.77 680.24 433.77 680.24 425.27 627.91 425.27 579.51 425.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.88 464.19 676.97 464.19 676.97 433.77 680.24 433.77 680.24 425.27 627.91 425.27 627.91 432.99 629.88 464.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.52,
    y: 438.68,
    width: 18.97,
    height: 4.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.08,
    y: 448.98,
    width: 24.36,
    height: 9.67,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "585.47 394.86 585.47 425.27 629.95 425.27 679 425.27 679 394.86 585.47 394.86",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "581.54 386.35 581.54 394.86 682.27 394.86 682.27 386.35 629.95 386.35 581.54 386.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.91 425.27 679 425.27 679 394.86 682.27 394.86 682.27 386.35 629.95 386.35 629.95 394.07 631.91 425.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.55,
    y: 399.76,
    width: 18.97,
    height: 4.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.11,
    y: 410.06,
    width: 24.36,
    height: 9.67,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.22,423.52c23.72-11.11,33.11-37.51,36.38-62.11.55-4.11,1.72-8.34.36-12.25s-5.55-7.12-9.54-6c-3.32.91-5.25,4.21-7.46,6.84a24.44,24.44,0,0,1-11.23,7.53c-2.87.9-6.26,1.18-8.63-.67-3.24-2.54-2.84-7.47-2.14-11.53l4-22.68c.71-4.06,1.42-8.2.78-12.27s-2.85-8.12-6.59-9.86-9-.32-10.44,3.52c-.62,1.6-.57,3.37-1,5s-1.51,3.4-3.21,3.6-3.18-1.23-4.21-2.62c-3.56-4.82-5.55-10.58-7.36-16.28s-3.53-11.52-6.63-16.64-7.84-9.55-13.68-10.86-12.71,1.22-15.16,6.68,0,11.85,2.86,17.1a92.62,92.62,0,0,0,16.1,21.19c1.14,1.12,2.39,2.34,2.63,3.93.44,2.85-2.61,5.11-5.47,5.55-3.24.49-6.51-.38-9.78-.54s-7,.65-8.7,3.44c-2.38,3.87.4,8.8,3.39,12.23A79.77,79.77,0,0,0,140.55,353c2.84,1.6,5.86,3.09,7.95,5.6s2.95,6.4,1,9-5.9,2.89-9,1.78-5.63-3.28-8.46-4.91c-5.3-3.05-12.67-3.89-17.1.33-2.91,2.77-3.86,7.15-3.29,11.13s2.46,7.64,4.55,11.08c7.3,12,17.48,22.4,29.85,29.08s24.31,9.93,38.14,7.41",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.33,407.12a367.18,367.18,0,0,0-8.06-41.61q-1.36-5.47-2.68-10.81c-.89-3.54-1.77-7.06-2.84-10.44a182.3,182.3,0,0,0-7.31-19.11c-2.62-6-5.32-11.54-7.89-16.73s-5.08-10-7.54-14.25a148.16,148.16,0,0,0-13.12-19.29c-1.72-2.15-3.11-3.78-4.07-4.87l-1.09-1.24c-.25-.27-.39-.4-.39-.4s.1.15.34.44l1,1.28c.92,1.12,2.28,2.77,4,4.94a154.39,154.39,0,0,1,12.93,19.36c2.43,4.27,4.9,9.07,7.46,14.26s5.23,10.77,7.83,16.73a185.33,185.33,0,0,1,7.24,19.06c1.07,3.37,1.94,6.86,2.83,10.41l2.67,10.8a372.9,372.9,0,0,1,8.1,41.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.6,344.17a9.37,9.37,0,0,0,.67-1.67c.39-1.09.92-2.68,1.54-4.66,1.25-3.94,2.79-9.45,4.48-15.53s3.33-11.56,4.66-15.47c.66-2,1.21-3.54,1.61-4.62a10.05,10.05,0,0,0,.55-1.72,10.85,10.85,0,0,0-.77,1.63c-.47,1.06-1.09,2.62-1.81,4.56-1.44,3.89-3.15,9.36-4.84,15.45s-3.17,11.48-4.3,15.58c-.55,1.9-1,3.48-1.35,4.71A10.41,10.41,0,0,0,166.6,344.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.34,325.57a2,2,0,0,0,.53.18l1.54.39c1.34.34,3.28.82,5.66,1.5,4.76,1.31,11.28,3.37,18.36,5.95s13.39,5.22,17.89,7.26c2.26,1,4.06,1.86,5.31,2.45l1.45.68a2,2,0,0,0,.52.19,2.08,2.08,0,0,0-.46-.31l-1.4-.77c-1.21-.66-3-1.59-5.23-2.64-4.47-2.14-10.77-4.84-17.87-7.44a192.8,192.8,0,0,0-18.46-5.79c-2.39-.63-4.36-1.05-5.72-1.31l-1.57-.29A2.08,2.08,0,0,0,115.34,325.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91,406a4.28,4.28,0,0,0,.45-.58c.32-.45.72-1,1.21-1.75,1.05-1.51,2.51-3.75,4.28-6.53,3.55-5.56,8.21-13.39,13.24-22.09s9.63-16.56,13.08-22.18l4.1-6.63c.46-.74.83-1.34,1.11-1.81a3.33,3.33,0,0,0,.36-.65,3.14,3.14,0,0,0-.46.58c-.31.46-.71,1-1.21,1.75-1,1.52-2.51,3.75-4.28,6.53-3.54,5.56-8.2,13.39-13.24,22.1s-9.63,16.56-13.07,22.17l-4.11,6.63-1.11,1.81A3.17,3.17,0,0,0,179.91,406Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.36,371.93a4.34,4.34,0,0,0,.66.38l1.93,1,7.14,3.64c6,3.09,14.28,7.45,23.4,12.3s17.42,9.15,23.49,12.14c3,1.49,5.51,2.68,7.23,3.47l2,.9a3.15,3.15,0,0,0,.72.27,3.79,3.79,0,0,0-.66-.39l-1.93-1L170.18,401c-6-3.09-14.28-7.46-23.4-12.3s-17.42-9.15-23.5-12.14c-3-1.49-5.5-2.68-7.22-3.47l-2-.9A3.2,3.2,0,0,0,113.36,371.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 636.32,
    cy: 135.17,
    r: 38.76,
    transform: "matrix(0.37, -0.93, 0.93, 0.37, 276.05, 676.81)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.92,136.36a7.17,7.17,0,0,1-1.37.09l-3.77.08c-3.2.05-7.65.08-12.68.09h-.26v-2.77c0-5.62,0-10.7.08-14.38,0-1.77.06-3.24.08-4.36a8.83,8.83,0,0,1,.1-1.59,8.83,8.83,0,0,1,.1,1.59c0,1.12,0,2.59.08,4.36.05,3.68.08,8.76.08,14.38v2.51l-.26-.26c5,0,9.48,0,12.68.09l3.77.08A8.4,8.4,0,0,1,653.92,136.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.22,102.77a10.58,10.58,0,0,1,.26,3.26,10.58,10.58,0,0,1-.26,3.26A10.58,10.58,0,0,1,636,106,10.58,10.58,0,0,1,636.22,102.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.88,108a10.08,10.08,0,0,1-2.08,2.46,10.29,10.29,0,0,1-2.46,2.08,10.06,10.06,0,0,1,2.09-2.45A10.34,10.34,0,0,1,653.88,108Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.21,119.28a12.58,12.58,0,0,1-2.67,1.8,12.92,12.92,0,0,1-2.82,1.54,8.34,8.34,0,0,1,2.55-2A8.51,8.51,0,0,1,664.21,119.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.26,136a38,38,0,0,1-8.88,0,38,38,0,0,1,8.88,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.69,135.43a33.89,33.89,0,0,1-8.38,0,33.89,33.89,0,0,1,8.38,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.05,147.9a18.91,18.91,0,0,1-3.17,2.88,17.21,17.21,0,0,1-3.49,2.47,18.43,18.43,0,0,1,3.17-2.88A17.58,17.58,0,0,1,613.05,147.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.79,157.53a27,27,0,0,1-2.15,3.75,26.2,26.2,0,0,1-2.3,3.65,13.77,13.77,0,0,1,1.85-3.92A14,14,0,0,1,623.79,157.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.22,170a19.31,19.31,0,0,1-.26-4.43,19.37,19.37,0,0,1,.26-4.44,19.37,19.37,0,0,1,.26,4.44A19.31,19.31,0,0,1,636.22,170Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.36,164.05a12.47,12.47,0,0,1-3.67-2.5,12.9,12.9,0,0,1-3-3.29,36.54,36.54,0,0,1,3.32,2.9A36.22,36.22,0,0,1,655.36,164.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.34,154.38a29.35,29.35,0,0,1-5.53-5.53,14.66,14.66,0,0,1,3,2.58A14.36,14.36,0,0,1,664.34,154.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.64,123.49a10.92,10.92,0,0,1-2.6-2.23,11.42,11.42,0,0,1-2.24-2.6,11.45,11.45,0,0,1,2.61,2.23A11.77,11.77,0,0,1,612.64,123.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.72,111.82a11.32,11.32,0,0,1-2.55-2.18,11.21,11.21,0,0,1-2.19-2.55,11.32,11.32,0,0,1,2.55,2.18A11,11,0,0,1,623.72,111.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.37,457.75c-1.23-1.05-4-4.39-1.86-8.27.78-1.42,2.43-2.12,3.93-2.75a16.09,16.09,0,0,0,4.3-2.22c2.33-2,3-5.26,4.53-7.89,1.77-3,5.09-5.3,8.6-5.14,4,.18,7.36,3.45,8.88,7.17s1.57,7.85,1.6,11.87c0,2.22-.08,4.73-1.72,6.23s-3.79,1.4-5.84,1.34l-21.94-.67",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.34,397.69h-57.7L225,459.38a6.93,6.93,0,0,0,4.93,5.5l.2.05c.17,0,.34.1.51.13a7.61,7.61,0,0,0,1.18.14v.06l.28-.05h25.72a7.33,7.33,0,0,0,1.41-.14,6.93,6.93,0,0,0,5.84-6l5-42.5.22-1.69h0l2-16.84ZM261.45,437h-5.92l.6-17.9H263Zm2.11-17.9h5.67L267.12,437H262Zm-16.91,37.75-.36-15.55h8.52l-.51,15.55Zm-9.22-15.55h8.28l.36,15.55h-7.43Zm.64,15.55h-6.95c-.66-4.2-1.52-9.66-2.45-15.55h8.19Zm-1-19.85-1.39-17.9h9.5l.42,17.9Zm9.1,0-.42-17.9h9.79L255,437Zm-.52-22.19-.38-16.58h11l-.55,16.58Zm-.57,0h-9.74l-1.29-16.58h10.65Zm-10.31,0H224.48c-.36-2.29-.71-4.46-1-6.41-1.08-6.7-1.48-9.23-1.71-10.17h11.74Zm.33,4.29,1.4,17.9H228c-.29-1.81-.58-3.65-.87-5.49l-2-12.41Zm-7.7,17.9h-5.57l-3-17.9h5.75C225.46,424.67,226.44,430.83,227.42,437Zm.67,4.3c.85,5.38,1.69,10.69,2.45,15.55h-5.35l-2.62-15.55Zm26.78,15.55.52-15.55h5.69l-1.33,15.55Zm1.4-42,.56-16.58h7.95l-1.42,16.58Zm-35.06-16.58c.23,1.19,1.28,7.72,2.69,16.58h-5.79l-2.79-16.58Zm43.57,58.62h-4.46l1.34-15.55h5Zm5-42h-5.81l1.43-16.58h6.33Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M678.69,466.12c0,.15-136,.26-303.68.26s-303.7-.11-303.7-.26,136-.26,303.7-.26S678.69,466,678.69,466.12Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.84,348.55s-5.94,4.13,4.74,16.29S110,382.67,110,382.67s2.09,2.93-.51,4.12-8.86,1.77-9.23,5.42,3,6.42,8.8,8,18.49,5.49,19.63,5.84,2.48,1.62.83,2.72-14.81,5.95-12.13,12.06,19.64,7.82,21.49,8,2.44.83,2.54,1.79-4.48,2.18-8.17,3.71-7.7,4-5.86,7.35,13,8.69,35.87,5.2l10.51-2.31,3.44-10.24c6-22.37,2-34-1.17-36.24s-6,1.51-8,5-3.65,7.91-4.6,7.71-1.48-.86-1.5-2.72.18-18.92-5.59-22.26-12.06,9.21-13.34,10.72-2.38,0-2.61-1.14-2.7-14.18-3.62-20.16-3.15-9.59-6.95-9.63-4.94,6.11-6.42,8.57-4.15,0-4.15,0S114.38,367,103.48,355s-15.76-6.37-15.76-6.37",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.38,359.46l.25.24.68.72,2.6,2.81c2.26,2.44,5.5,6,9.48,10.41,8,8.82,18.88,21.1,30.88,34.7s22.89,25.91,30.81,34.77l9.39,10.49,2.55,2.86.66.74a3.46,3.46,0,0,1,.22.27l-.25-.24c-.16-.18-.39-.42-.68-.72l-2.6-2.81c-2.26-2.45-5.49-6-9.48-10.41-8-8.82-18.88-21.1-30.89-34.71s-22.88-25.9-30.8-34.76l-9.39-10.49-2.56-2.86-.65-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,391.77a3,3,0,0,1,.78,0c.5,0,1.22.09,2.11.18,1.78.18,4.23.5,6.93.9l6.89,1,2.09.31a2.83,2.83,0,0,1,.77.15,3.59,3.59,0,0,1-.78,0c-.5,0-1.22-.09-2.11-.19-1.78-.2-4.22-.55-6.92-.94l-6.9-1-2.09-.3A3.41,3.41,0,0,1,109,391.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.11,393.51c-.1,0,.32-5.09.95-11.34s1.2-11.32,1.3-11.31-.32,5.09-.94,11.35S129.21,393.52,129.11,393.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.61,415.23a2.55,2.55,0,0,1,.25-.75c.22-.55.49-1.22.8-2,.68-1.69,1.6-4,2.53-6.65s1.69-5,2.23-6.75c.26-.81.47-1.5.65-2.06a3.46,3.46,0,0,1,.27-.75,2.61,2.61,0,0,1-.14.78c-.11.5-.29,1.22-.53,2.1-.48,1.76-1.2,4.18-2.14,6.8s-1.89,5-2.63,6.63c-.37.84-.68,1.51-.91,2A4.1,4.1,0,0,1,146.61,415.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.07,417.66a2.55,2.55,0,0,1,.71-.18l2-.34c1.66-.27,4-.62,6.51-1s4.85-.68,6.52-.88c.84-.11,1.52-.19,2-.23a3.1,3.1,0,0,1,.73,0,2.55,2.55,0,0,1-.71.18l-2,.34c-1.66.27-4,.62-6.51,1s-4.85.68-6.52.89c-.84.1-1.52.18-2,.22A3.1,3.1,0,0,1,128.07,417.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.08,438.79a4.72,4.72,0,0,1,.91-.21l2.52-.44c2.13-.37,5.08-.84,8.33-1.34s6.21-.93,8.35-1.23l2.54-.33a4.12,4.12,0,0,1,.94-.07,5.3,5.3,0,0,1-.92.21l-2.52.45c-2.13.36-5.07.83-8.33,1.33s-6.21.93-8.35,1.23l-2.53.33A4.14,4.14,0,0,1,141.08,438.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.08,435.1a4.33,4.33,0,0,1,.3-1l.92-2.57c.78-2.18,1.85-5.19,2.94-8.54s2-6.42,2.64-8.64l.77-2.63a6.4,6.4,0,0,1,.32-.95,4.75,4.75,0,0,1-.18,1c-.14.63-.37,1.54-.66,2.66-.58,2.24-1.45,5.32-2.55,8.68s-2.19,6.36-3,8.52c-.42,1.07-.77,1.94-1,2.54A6.61,6.61,0,0,1,164.08,435.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--control-panel--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.94,336.36s.18.21.5.63.81,1.07,1.41,1.92a56,56,0,0,1,4.53,7.95,57.32,57.32,0,0,1,4.31,13.8,61.15,61.15,0,0,1,.85,9,56.12,56.12,0,0,1-.84,10.11,54.22,54.22,0,0,1-8.85,21.37,56.11,56.11,0,0,1-19.77,17.67,49.09,49.09,0,0,1-13.64,4.73,39,39,0,0,1-15-.05,32.8,32.8,0,0,1-7.38-2.45,30.73,30.73,0,0,1-6.58-4.37,29,29,0,0,1-8.82-13.32,23.56,23.56,0,0,1-1-8.07,19.78,19.78,0,0,1,2-7.77,16.46,16.46,0,0,1,5-6.14,12.55,12.55,0,0,1,7.36-2.47,12,12,0,0,1,7.29,2.22,9.74,9.74,0,0,1,2.58,2.81,10.08,10.08,0,0,1,1.22,3.58,12.07,12.07,0,0,1-1.52,7.17,14.49,14.49,0,0,1-4.87,5.26A15.23,15.23,0,0,1,518,402.1a20.82,20.82,0,0,1-6.79-.56,32.88,32.88,0,0,1-11.65-5.63,44.81,44.81,0,0,1-4.73-4,45.72,45.72,0,0,1-4-4.44,44.32,44.32,0,0,1-5.74-9.57,42.62,42.62,0,0,1-3.63-18.73,43.74,43.74,0,0,1,1-7.81,42.28,42.28,0,0,1,1.86-6.35,41.59,41.59,0,0,1,4.1-8.17c.55-.9,1-1.52,1.35-2s.49-.65.49-.65-.14.24-.45.68-.77,1.08-1.3,2a42.67,42.67,0,0,0-4,8.19,43.31,43.31,0,0,0,.95,32.67,43.67,43.67,0,0,0,5.72,9.48,46,46,0,0,0,3.94,4.38,43.74,43.74,0,0,0,4.69,3.93,32.64,32.64,0,0,0,11.51,5.54,20.22,20.22,0,0,0,6.64.53,14.67,14.67,0,0,0,6.45-2.07,14.11,14.11,0,0,0,4.7-5.09,11.66,11.66,0,0,0,1.46-6.87,9.75,9.75,0,0,0-1.16-3.39,9,9,0,0,0-2.45-2.66,11.48,11.48,0,0,0-7-2.12,12,12,0,0,0-7.06,2.37,16,16,0,0,0-4.81,5.95,19.38,19.38,0,0,0-1.92,7.58,22.76,22.76,0,0,0,.94,7.89,28.43,28.43,0,0,0,8.66,13.08,30.72,30.72,0,0,0,6.47,4.3A32.49,32.49,0,0,0,529.5,423a38.46,38.46,0,0,0,14.85.06,48.25,48.25,0,0,0,13.51-4.67,55.73,55.73,0,0,0,19.64-17.48,54.05,54.05,0,0,0,8.84-21.2,55.34,55.34,0,0,0,.87-10,62.19,62.19,0,0,0-.8-9A56.38,56.38,0,0,0,577.77,339c-.6-.85-1.06-1.49-1.37-1.94S575.94,336.36,575.94,336.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.8,326.43s-.8,4.62-3.13,12.77a144.14,144.14,0,0,1-5.06,14.59A114.45,114.45,0,0,1,390.24,372a89.5,89.5,0,0,1-16.08,18.81,73.11,73.11,0,0,1-24.45,14.34,59.45,59.45,0,0,1-15.09,3,56.89,56.89,0,0,1-16-1.22,55.06,55.06,0,0,1-15.48-6.05,45.73,45.73,0,0,1-12.94-11.19,35.93,35.93,0,0,1-4.57-7.35,30.29,30.29,0,0,1-2.53-8.16,23.12,23.12,0,0,1,.19-8.42,17.94,17.94,0,0,1,3.62-7.45,19.18,19.18,0,0,1,6.41-5,15,15,0,0,1,7.86-1.39,12.71,12.71,0,0,1,7.06,3.32,15.56,15.56,0,0,1,3.93,6.56,16.48,16.48,0,0,1-2,14.19,20.67,20.67,0,0,1-11.29,7.73,24.68,24.68,0,0,1-12.84.2A33.86,33.86,0,0,1,275.17,379,53.52,53.52,0,0,1,261,364.31a61.19,61.19,0,0,1-6.84-13.82,58.6,58.6,0,0,1-2.42-9.45c-.37-2.2-.45-3.37-.45-3.37s.06.29.14.85.2,1.41.42,2.5a60.07,60.07,0,0,0,2.5,9.4,61.62,61.62,0,0,0,6.89,13.73,53.55,53.55,0,0,0,14.12,14.51,33.45,33.45,0,0,0,10.72,4.83,24.38,24.38,0,0,0,12.62-.22,20.19,20.19,0,0,0,11-7.58,16,16,0,0,0,2-13.79,15,15,0,0,0-3.81-6.34,12.18,12.18,0,0,0-6.78-3.18,14.38,14.38,0,0,0-7.58,1.35,18.47,18.47,0,0,0-6.23,4.89,17.29,17.29,0,0,0-3.51,7.24,22.53,22.53,0,0,0-.19,8.23,29.84,29.84,0,0,0,2.49,8,34.64,34.64,0,0,0,4.51,7.24,45.16,45.16,0,0,0,12.79,11.07,54.65,54.65,0,0,0,15.33,6,57,57,0,0,0,15.87,1.21,59.19,59.19,0,0,0,15-3,72.73,72.73,0,0,0,24.31-14.2,89.17,89.17,0,0,0,16.06-18.69,115.15,115.15,0,0,0,9.41-18.07,146.14,146.14,0,0,0,5.13-14.53c1.22-4.06,2-7.26,2.53-9.42.25-1.07.45-1.9.58-2.47S407.8,326.43,407.8,326.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.22,
    y: 319.9,
    width: 420.31,
    height: 17.93,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.28,287.78c.7-6.5,0-235,0-235H569.47V291.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.7,206.6c0-1-.05-23.48-.14-65.23l.14.13-370.5.13h0l.26-.26V206.6l-.26-.26,370.52.26-370.52.25h-.26V141.11h.28l370.5.12h.13v.14C558.75,183.12,558.7,205.6,558.7,206.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.83,
    y: 147.36,
    width: 19.44,
    height: 51.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.14,199.23s0-.33,0-.95,0-1.55,0-2.74c0-2.4,0-5.92-.05-10.41,0-9-.07-21.95-.11-37.77l.2.2-82.31.06h0l.26-.26c0,18.39,0,35.92,0,51.87l-.24-.24,59.21.12,17,.06,4.53,0h1.18l.4,0h-.37l-1.15,0-4.48,0-16.94.06-59.37.12h-.24v-.24c0-15.95,0-33.48,0-51.87v-.26h.26l82.31.05h.21v.21c-.05,15.87-.08,28.86-.11,37.89,0,4.48,0,8-.05,10.38,0,1.17,0,2.07,0,2.69S428.14,199.23,428.14,199.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.63,
    y: 149.27,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.24,157.88H287.6v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 149.27,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.94,157.88H301.3v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.02,
    y: 149.27,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.64,157.88H315v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.72,
    y: 149.27,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.34,157.88H328.7v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.63,
    y: 162.62,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.24,171.23H287.6v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 162.62,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.94,171.23H301.3v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.02,
    y: 162.62,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.64,171.23H315v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.72,
    y: 162.62,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.34,171.23H328.7v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.63,
    y: 175.97,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.24,184.58H287.6v-8.64h8.64Zm-8.59-.05h8.54V176h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 175.97,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.94,184.58H301.3v-8.64h8.64Zm-8.59-.05h8.54V176h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.02,
    y: 175.97,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.64,184.58H315v-8.64h8.64Zm-8.59-.05h8.54V176h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.72,
    y: 175.97,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.34,184.58H328.7v-8.64h8.64Zm-8.59-.05h8.54V176h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.63,
    y: 189.31,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.24,197.93H287.6v-8.64h8.64Zm-8.59-.05h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 189.31,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.94,197.93H301.3v-8.64h8.64Zm-8.59-.05h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.02,
    y: 189.31,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.64,197.93H315v-8.64h8.64Zm-8.59-.05h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.72,
    y: 189.31,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.34,197.93H328.7v-8.64h8.64Zm-8.59-.05h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.1,199.23s0-.34,0-1,0-1.58,0-2.79c0-2.45,0-6-.05-10.53,0-9.07-.07-22-.12-37.58l.22.22-59.94,0h0l.26-.26c0,18.83,0,36.57,0,51.87l-.23-.23,43.31.11,12.25.07,3.25,0,.84,0h0l-.82,0-3.2,0-12.2.06-43.46.12h-.23v-.23c0-15.3,0-33,0-51.87v-.26h.26l59.94,0h.22v.22c0,15.63-.08,28.62-.11,37.72,0,4.5,0,8-.06,10.48,0,1.19,0,2.1,0,2.75S280.1,199.23,280.1,199.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.6,193.61c-.14,0-.26-9-.26-20s.12-20,.26-20,.26,9,.26,20S229.75,193.61,229.6,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.68,193.61c-.15,0-.26-9-.26-20s.11-20,.26-20,.26,9,.26,20S239.82,193.61,239.68,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.75,193.61c-.14,0-.26-9-.26-20s.12-20,.26-20,.26,9,.26,20S249.9,193.61,249.75,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83,193.61c-.15,0-.26-9-.26-20s.11-20,.26-20,.26,9,.26,20S260,193.61,259.83,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.9,193.61c-.14,0-.26-9-.26-20s.12-20,.26-20,.26,9,.26,20S270.05,193.61,269.9,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.67,
    cy: 189.23,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.67,190.61a1.39,1.39,0,1,1,1.38-1.38A1.38,1.38,0,0,1,229.67,190.61Zm0-2.72a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,229.67,187.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.68,
    cy: 178.48,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.68,179.87a1.39,1.39,0,1,1,1.38-1.39A1.39,1.39,0,0,1,239.68,179.87Zm0-2.72a1.34,1.34,0,1,0,1.33,1.33A1.33,1.33,0,0,0,239.68,177.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.34,
    cy: 169.08,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.34,170.47a1.39,1.39,0,1,1,1.38-1.39A1.39,1.39,0,0,1,249.34,170.47Zm0-2.73a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,249.34,167.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.65,
    cy: 189.91,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.65,191.3a1.39,1.39,0,1,1,1.38-1.39A1.39,1.39,0,0,1,259.65,191.3Zm0-2.73a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,259.65,188.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.9,
    cy: 157.86,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.9,159.24a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,269.9,159.24Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.33,1.33,0,0,0,269.9,156.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.81,199.23s0-.34,0-1,0-1.58,0-2.79c0-2.45,0-6-.06-10.53,0-9.07-.06-22-.11-37.58l.22.22-59.94,0h0l.26-.26c0,18.83,0,36.57,0,51.87l-.23-.23,43.31.11,12.25.07,3.25,0,.85,0h0l-.81,0-3.21,0-12.2.06-43.46.12h-.23v-.23c0-15.3,0-33,0-51.87v-.26h.27l59.94,0H493v.22c0,15.63-.09,28.62-.11,37.72,0,4.5-.05,8-.06,10.48,0,1.19,0,2.1,0,2.75S492.81,199.23,492.81,199.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.31,193.61c-.15,0-.26-9-.26-20s.11-20,.26-20,.26,9,.26,20S442.45,193.61,442.31,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.38,193.61c-.14,0-.26-9-.26-20s.12-20,.26-20,.26,9,.26,20S452.53,193.61,452.38,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.46,193.61c-.15,0-.26-9-.26-20s.11-20,.26-20,.26,9,.26,20S462.6,193.61,462.46,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.53,193.61c-.14,0-.26-9-.26-20s.12-20,.26-20,.26,9,.26,20S472.68,193.61,472.53,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.61,193.61c-.15,0-.26-9-.26-20s.11-20,.26-20,.26,9,.26,20S482.75,193.61,482.61,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.73,189.23a1.36,1.36,0,1,1-1.36-1.36A1.36,1.36,0,0,1,443.73,189.23Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.37,190.61a1.39,1.39,0,1,1,1.39-1.38A1.39,1.39,0,0,1,442.37,190.61Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,442.37,187.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452.38,
    cy: 178.48,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.38,179.87a1.39,1.39,0,1,1,1.39-1.39A1.38,1.38,0,0,1,452.38,179.87Zm0-2.72a1.34,1.34,0,1,0,1.34,1.33A1.33,1.33,0,0,0,452.38,177.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462.04,
    cy: 169.08,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,170.47a1.39,1.39,0,1,1,1.39-1.39A1.39,1.39,0,0,1,462,170.47Zm0-2.73a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,462,167.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.35,
    cy: 189.91,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.35,191.3a1.39,1.39,0,1,1,1.39-1.39A1.4,1.4,0,0,1,472.35,191.3Zm0-2.73a1.34,1.34,0,1,0,1.34,1.34A1.33,1.33,0,0,0,472.35,188.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482.61,
    cy: 157.86,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.61,159.24a1.39,1.39,0,1,1,1.38-1.38A1.38,1.38,0,0,1,482.61,159.24Zm0-2.72a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,482.61,156.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.43,
    cy: 154.95,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.67,
    cy: 154.95,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.3,155a1.39,1.39,0,1,1-1.39-1.39A1.38,1.38,0,0,1,375.3,155Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.16,
    cy: 154.95,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.4,
    cy: 154.95,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,155a1.39,1.39,0,1,1-1.38-1.39A1.38,1.38,0,0,1,403,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.89,
    cy: 154.95,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.52,155a1.39,1.39,0,1,1-1.39-1.39A1.38,1.38,0,0,1,421.52,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.43,
    cy: 163.78,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.67,
    cy: 163.78,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.3,163.78a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,375.3,163.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.16,
    cy: 163.78,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.4,
    cy: 163.78,
    r: 1.38,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,163.78a1.39,1.39,0,1,1-1.38-1.38A1.38,1.38,0,0,1,403,163.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.89,
    cy: 163.78,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.52,163.78a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,421.52,163.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.43,
    cy: 172.62,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.67,
    cy: 172.62,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.3,172.62a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,375.3,172.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.16,
    cy: 172.62,
    r: 1.38,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.4,
    cy: 172.62,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,172.62a1.39,1.39,0,1,1-1.38-1.38A1.38,1.38,0,0,1,403,172.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.89,
    cy: 172.62,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.52,172.62a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,421.52,172.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.81,181.46a1.39,1.39,0,1,1-1.38-1.39A1.38,1.38,0,0,1,356.81,181.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.06,181.46a1.39,1.39,0,1,1-1.39-1.39A1.38,1.38,0,0,1,366.06,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.3,181.46a1.39,1.39,0,1,1-1.39-1.39A1.38,1.38,0,0,1,375.3,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.54,181.46a1.39,1.39,0,1,1-1.38-1.39A1.38,1.38,0,0,1,384.54,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.79,181.46a1.39,1.39,0,1,1-1.39-1.39A1.38,1.38,0,0,1,393.79,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,181.46a1.39,1.39,0,1,1-1.38-1.39A1.38,1.38,0,0,1,403,181.46Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.27,181.46a1.38,1.38,0,1,1-1.38-1.39A1.38,1.38,0,0,1,412.27,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.52,181.46a1.39,1.39,0,1,1-1.39-1.39A1.38,1.38,0,0,1,421.52,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.81,190.29a1.39,1.39,0,1,1-1.38-1.38A1.38,1.38,0,0,1,356.81,190.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.06,190.29a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,366.06,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.3,190.29a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,375.3,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.54,190.29a1.39,1.39,0,1,1-1.38-1.38A1.38,1.38,0,0,1,384.54,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.79,190.29a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,393.79,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,190.29a1.39,1.39,0,1,1-1.38-1.38A1.38,1.38,0,0,1,403,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.27,190.29a1.38,1.38,0,1,1-1.38-1.38A1.38,1.38,0,0,1,412.27,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.52,190.29a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,421.52,190.29Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.81,
    y: 147.36,
    width: 7.59,
    height: 7.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.43,155h-7.64v-7.64h7.64Zm-7.59-.05h7.54v-7.54h-7.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.81,
    y: 157.78,
    width: 7.59,
    height: 7.59,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.43,165.4h-7.64v-7.64h7.64Zm-7.59-.05h7.54v-7.54h-7.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.81,
    y: 168.2,
    width: 7.59,
    height: 7.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.43,175.82h-7.64v-7.64h7.64Zm-7.59,0h7.54v-7.54h-7.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.81,
    y: 178.63,
    width: 7.59,
    height: 7.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.43,186.24h-7.64V178.6h7.64Zm-7.59,0h7.54v-7.55h-7.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.81,
    y: 189.05,
    width: 7.59,
    height: 7.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.43,196.67h-7.64V189h7.64Zm-7.59,0h7.54v-7.54h-7.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.25,
    y: 147.36,
    width: 44.01,
    height: 51.1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.28,198.48h-44V147.33h44Zm-44,0h44V147.38h-44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.18,213.88c0,1,0,23.48.14,65.23l-.14-.13,370.5-.13h0l-.26.26V213.88l.26.26-370.52-.26,370.52-.25H559v65.74h-.28l-370.5-.12h-.13v-.14C188.13,237.36,188.18,214.88,188.18,213.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.61,
    y: 221.25,
    width: 19.44,
    height: 51.87,
    transform: "translate(1086.66 494.37) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.73,221.25s0,.33,0,.95,0,1.55,0,2.74c0,2.4,0,5.92.05,10.41,0,9,.06,22,.11,37.77l-.21-.2,82.32-.06h0l-.26.26c0-18.39,0-35.92,0-51.87l.24.24-59.21-.12-17-.06-4.53,0-1.18,0h0l1.15,0,4.48,0,16.94-.06,59.37-.12h.24v.24c0,15.95,0,33.48,0,51.87v.26h-.26l-82.32-.05h-.2v-.21c0-15.87.08-28.86.11-37.89,0-4.48,0-8,.05-10.38,0-1.17,0-2.07,0-2.69S318.73,221.25,318.73,221.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.66,
    y: 262.62,
    width: 8.59,
    height: 8.59,
    transform: "translate(909.91 533.83) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.28,271.24h-8.65V262.6h8.65Zm-8.59-.05h8.53v-8.54h-8.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.96,
    y: 262.62,
    width: 8.59,
    height: 8.59,
    transform: "translate(882.52 533.83) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.58,271.24h-8.64V262.6h8.64Zm-8.59-.05h8.54v-8.54H437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.27,
    y: 262.62,
    width: 8.59,
    height: 8.59,
    transform: "translate(855.12 533.83) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.88,271.24h-8.64V262.6h8.64Zm-8.59-.05h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.57,
    y: 262.62,
    width: 8.59,
    height: 8.59,
    transform: "translate(827.73 533.83) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.18,271.24h-8.64V262.6h8.64Zm-8.59-.05h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.66,
    y: 249.27,
    width: 8.59,
    height: 8.59,
    transform: "translate(909.91 507.14) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.28,257.89h-8.65v-8.64h8.65Zm-8.59-.05h8.53V249.3h-8.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.96,
    y: 249.27,
    width: 8.59,
    height: 8.59,
    transform: "translate(882.52 507.14) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.58,257.89h-8.64v-8.64h8.64Zm-8.59-.05h8.54V249.3H437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.27,
    y: 249.27,
    width: 8.59,
    height: 8.59,
    transform: "translate(855.12 507.14) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.88,257.89h-8.64v-8.64h8.64Zm-8.59-.05h8.54V249.3h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.57,
    y: 249.27,
    width: 8.59,
    height: 8.59,
    transform: "translate(827.73 507.14) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.18,257.89h-8.64v-8.64h8.64Zm-8.59-.05h8.54V249.3h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.66,
    y: 235.92,
    width: 8.59,
    height: 8.59,
    transform: "translate(909.91 480.44) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.28,244.54h-8.65V235.9h8.65Zm-8.59,0h8.53V236h-8.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.96,
    y: 235.92,
    width: 8.59,
    height: 8.59,
    transform: "translate(882.52 480.44) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.58,244.54h-8.64V235.9h8.64Zm-8.59,0h8.54V236H437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.27,
    y: 235.92,
    width: 8.59,
    height: 8.59,
    transform: "translate(855.12 480.44) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.88,244.54h-8.64V235.9h8.64Zm-8.59,0h8.54V236h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.57,
    y: 235.92,
    width: 8.59,
    height: 8.59,
    transform: "translate(827.73 480.44) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.18,244.54h-8.64V235.9h8.64Zm-8.59,0h8.54V236h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.66,
    y: 222.58,
    width: 8.59,
    height: 8.59,
    transform: "translate(909.91 453.74) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.28,231.19h-8.65v-8.64h8.65Zm-8.59-.05h8.53V222.6h-8.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.96,
    y: 222.58,
    width: 8.59,
    height: 8.59,
    transform: "translate(882.52 453.74) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.58,231.19h-8.64v-8.64h8.64Zm-8.59-.05h8.54V222.6H437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.27,
    y: 222.58,
    width: 8.59,
    height: 8.59,
    transform: "translate(855.12 453.74) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.88,231.19h-8.64v-8.64h8.64Zm-8.59-.05h8.54V222.6h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.57,
    y: 222.58,
    width: 8.59,
    height: 8.59,
    transform: "translate(827.73 453.74) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.18,231.19h-8.64v-8.64h8.64Zm-8.59-.05h8.54V222.6h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.77,221.25s0,.34,0,1,0,1.58,0,2.79c0,2.45,0,6,.06,10.53,0,9.07.07,22,.11,37.58l-.22-.22,59.94,0h0l-.26.26c0-18.83,0-36.57,0-51.87l.23.23-43.31-.11-12.25-.07-3.25,0-.84,0h0l.82,0,3.2,0,12.2-.06,43.46-.12H527v.23c0,15.3,0,33,0,51.87v.26h-.27l-59.94,0h-.22v-.22c0-15.63.08-28.62.11-37.72,0-4.5,0-8.05.06-10.48,0-1.19,0-2.11,0-2.75S466.77,221.25,466.77,221.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.28,226.87c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S517.13,226.87,517.28,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.2,226.87c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S507.06,226.87,507.2,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.13,226.87c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S497,226.87,497.13,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.05,226.87c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S486.91,226.87,487.05,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,226.87c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S476.83,226.87,477,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 517.21,
    cy: 231.25,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.21,232.64a1.39,1.39,0,1,1,1.39-1.39A1.38,1.38,0,0,1,517.21,232.64Zm0-2.73a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,517.21,229.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.2,
    cy: 242,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.2,243.38a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,507.2,243.38Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.33,1.33,0,0,0,507.2,240.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.54,
    cy: 251.4,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.54,252.79a1.39,1.39,0,1,1,1.39-1.39A1.4,1.4,0,0,1,497.54,252.79Zm0-2.73a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,497.54,250.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.23,
    cy: 230.57,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.23,232a1.39,1.39,0,1,1,1.39-1.39A1.39,1.39,0,0,1,487.23,232Zm0-2.73a1.34,1.34,0,1,0,1.34,1.34A1.33,1.33,0,0,0,487.23,229.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.98,
    cy: 262.62,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,264a1.39,1.39,0,1,1,1.38-1.39A1.39,1.39,0,0,1,477,264Zm0-2.72a1.34,1.34,0,1,0,1.33,1.33A1.34,1.34,0,0,0,477,261.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.07,221.25s0,.34,0,1,0,1.58,0,2.79c0,2.45,0,6,.06,10.53,0,9.07.06,22,.11,37.58l-.22-.22,59.94,0h0l-.26.26c0-18.83,0-36.57,0-51.87l.23.23-43.3-.11-12.25-.07-3.26,0-.84,0h0l.81,0,3.21,0,12.2-.06L314,221h.24v.23c0,15.3,0,33,0,51.87v.26H314l-59.94,0h-.22v-.22c.05-15.63.09-28.62.11-37.72,0-4.5,0-8.05.06-10.48,0-1.19,0-2.11,0-2.75S254.07,221.25,254.07,221.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.57,226.87c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S304.43,226.87,304.57,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5,226.87c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S294.35,226.87,294.5,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.42,226.87c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S284.28,226.87,284.42,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.35,226.87c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S274.2,226.87,274.35,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.27,226.87c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S264.13,226.87,264.27,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.51,
    cy: 231.25,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.51,232.64a1.39,1.39,0,1,1,1.38-1.39A1.39,1.39,0,0,1,304.51,232.64Zm0-2.73a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,304.51,229.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 242,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5,243.38a1.39,1.39,0,1,1,1.38-1.38A1.38,1.38,0,0,1,294.5,243.38Zm0-2.72a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,294.5,240.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.84,
    cy: 251.4,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,252.79a1.39,1.39,0,1,1,1.38-1.39A1.39,1.39,0,0,1,284.84,252.79Zm0-2.73a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,284.84,250.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.53,
    cy: 230.57,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.53,232a1.39,1.39,0,1,1,1.38-1.39A1.39,1.39,0,0,1,274.53,232Zm0-2.73a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,274.53,229.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.27,
    cy: 262.62,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.27,264a1.39,1.39,0,1,1,1.39-1.39A1.38,1.38,0,0,1,264.27,264Zm0-2.72a1.34,1.34,0,1,0,1.34,1.33A1.34,1.34,0,0,0,264.27,261.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.45,
    cy: 265.53,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.21,
    cy: 265.53,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,265.53a1.39,1.39,0,1,1,1.38,1.39A1.38,1.38,0,0,1,371.58,265.53Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.72,
    cy: 265.53,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 265.53,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.85,265.53a1.39,1.39,0,1,1,1.38,1.39A1.38,1.38,0,0,1,343.85,265.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.99,
    cy: 265.53,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.75,
    cy: 265.53,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.07,256.7a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,390.07,256.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.82,256.7a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,380.82,256.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,256.7a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,371.58,256.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,256.7a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,362.34,256.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.09,256.7a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,353.09,256.7Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.85,256.7a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,343.85,256.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.6,256.7a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,334.6,256.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.36,256.7a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,325.36,256.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.07,247.86a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,390.07,247.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.82,247.86a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,380.82,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,247.86a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,371.58,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,247.86a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,362.34,247.86Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.09,247.86a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,353.09,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.85,247.86a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,343.85,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.6,247.86a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,334.6,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.36,247.86a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,325.36,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.45,
    cy: 239.02,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.21,
    cy: 239.02,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,239a1.39,1.39,0,1,1,1.38,1.39A1.38,1.38,0,0,1,371.58,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.72,
    cy: 239.02,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 239.02,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.85,239a1.39,1.39,0,1,1,1.38,1.39A1.38,1.38,0,0,1,343.85,239Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.99,
    cy: 239.02,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.75,
    cy: 239.02,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.45,
    cy: 230.19,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.21,
    cy: 230.19,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,230.19a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,371.58,230.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.72,
    cy: 230.19,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 230.19,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.85,230.19a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,343.85,230.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.99,
    cy: 230.19,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.75,
    cy: 230.19,
    r: 1.38,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.47,
    y: 265.53,
    width: 7.59,
    height: 7.59,
    transform: "translate(490.54 538.66) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,273.15h-7.64v-7.64h7.64Zm-7.59,0H249v-7.54H241.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.47,
    y: 255.11,
    width: 7.59,
    height: 7.59,
    transform: "translate(490.54 517.81) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,262.72h-7.64v-7.64h7.64Zm-7.59-.05H249v-7.54H241.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.47,
    y: 244.68,
    width: 7.59,
    height: 7.59,
    transform: "translate(490.54 496.96) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,252.3h-7.64v-7.64h7.64Zm-7.59-.05H249v-7.54H241.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.47,
    y: 234.26,
    width: 7.59,
    height: 7.59,
    transform: "translate(490.54 476.11) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,241.88h-7.64v-7.65h7.64Zm-7.59,0H249v-7.55H241.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.47,
    y: 223.84,
    width: 7.59,
    height: 7.59,
    transform: "translate(490.54 455.26) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,231.45h-7.64v-7.64h7.64Zm-7.59,0H249v-7.54H241.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.62,
    y: 222.02,
    width: 44.01,
    height: 51.1,
    transform: "translate(429.25 495.14) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.65,273.15H192.59V222h44.06Zm-44,0h44V222.05h-44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.18,63c0,1,0,23.48.14,65.23l-.14-.14,370.5-.12h0l-.26.26V63l.26.26L188.18,63l370.52-.26H559v65.75h-.28l-370.5-.13h-.13v-.13C188.13,86.48,188.18,64,188.18,63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.61,
    y: 70.37,
    width: 19.44,
    height: 51.87,
    transform: "translate(1086.66 192.61) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.73,70.37s0,.33,0,.95,0,1.54,0,2.73c0,2.41,0,5.92.05,10.42,0,9,.06,22,.11,37.77l-.21-.21,82.32,0h0l-.26.26c0-18.4,0-35.93,0-51.87l.24.24-59.21-.12-17-.07-4.53,0-1.18,0h-.41l.38,0h1.15l4.48,0,16.94-.07,59.37-.11h.24v.24c0,15.94,0,33.47,0,51.87v.26h-.26l-82.32-.06h-.2v-.2c0-15.88.08-28.86.11-37.9,0-4.48,0-8,.05-10.37,0-1.17,0-2.07,0-2.7S318.73,70.37,318.73,70.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.66,
    y: 111.74,
    width: 8.59,
    height: 8.59,
    transform: "translate(909.91 232.07) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.28,120.35h-8.65v-8.64h8.65Zm-8.59,0h8.53v-8.54h-8.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.96,
    y: 111.74,
    width: 8.59,
    height: 8.59,
    transform: "translate(882.52 232.07) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.58,120.35h-8.64v-8.64h8.64Zm-8.59,0h8.54v-8.54H437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.27,
    y: 111.74,
    width: 8.59,
    height: 8.59,
    transform: "translate(855.12 232.07) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.88,120.35h-8.64v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.57,
    y: 111.74,
    width: 8.59,
    height: 8.59,
    transform: "translate(827.73 232.07) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.18,120.35h-8.64v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.66,
    y: 98.39,
    width: 8.59,
    height: 8.59,
    transform: "translate(909.91 205.37) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.28,107h-8.65V98.36h8.65Zm-8.59,0h8.53V98.41h-8.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.96,
    y: 98.39,
    width: 8.59,
    height: 8.59,
    transform: "translate(882.52 205.37) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.58,107h-8.64V98.36h8.64ZM437,107h8.54V98.41H437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.27,
    y: 98.39,
    width: 8.59,
    height: 8.59,
    transform: "translate(855.12 205.37) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.88,107h-8.64V98.36h8.64Zm-8.59,0h8.54V98.41h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.57,
    y: 98.39,
    width: 8.59,
    height: 8.59,
    transform: "translate(827.73 205.37) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.18,107h-8.64V98.36h8.64Zm-8.59,0h8.54V98.41h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.66,
    y: 85.04,
    width: 8.59,
    height: 8.59,
    transform: "translate(909.91 178.67) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.28,93.66h-8.65V85h8.65Zm-8.59,0h8.53V85.07h-8.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.96,
    y: 85.04,
    width: 8.59,
    height: 8.59,
    transform: "translate(882.52 178.67) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.58,93.66h-8.64V85h8.64Zm-8.59,0h8.54V85.07H437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.27,
    y: 85.04,
    width: 8.59,
    height: 8.59,
    transform: "translate(855.12 178.67) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.88,93.66h-8.64V85h8.64Zm-8.59,0h8.54V85.07h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.57,
    y: 85.04,
    width: 8.59,
    height: 8.59,
    transform: "translate(827.73 178.67) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.18,93.66h-8.64V85h8.64Zm-8.59,0h8.54V85.07h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.66,
    y: 71.69,
    width: 8.59,
    height: 8.59,
    transform: "translate(909.91 151.97) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.28,80.31h-8.65V71.67h8.65Zm-8.59,0h8.53V71.72h-8.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.96,
    y: 71.69,
    width: 8.59,
    height: 8.59,
    transform: "translate(882.52 151.97) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.58,80.31h-8.64V71.67h8.64Zm-8.59,0h8.54V71.72H437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.27,
    y: 71.69,
    width: 8.59,
    height: 8.59,
    transform: "translate(855.12 151.97) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.88,80.31h-8.64V71.67h8.64Zm-8.59,0h8.54V71.72h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.57,
    y: 71.69,
    width: 8.59,
    height: 8.59,
    transform: "translate(827.73 151.97) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.18,80.31h-8.64V71.67h8.64Zm-8.59,0h8.54V71.72h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.77,70.37s0,.34,0,1,0,1.58,0,2.78c0,2.45,0,6,.06,10.54,0,9.06.07,22,.11,37.58l-.22-.22,59.94,0h0l-.26.26c0-18.83,0-36.57,0-51.87l.23.23-43.31-.12-12.25-.06-3.25,0h-1.14a1.39,1.39,0,0,1,.27,0h.82l3.2,0,12.2-.06,43.46-.11H527v.23c0,15.3,0,33,0,51.87v.26h-.27l-59.94,0h-.22v-.22c0-15.64.08-28.62.11-37.72,0-4.51,0-8,.06-10.49,0-1.18,0-2.1,0-2.74S466.77,70.37,466.77,70.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.28,76c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S517.13,76,517.28,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.2,76c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S507.06,76,507.2,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.13,76c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S497,76,497.13,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.05,76c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S486.91,76,487.05,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,76c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S476.83,76,477,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 517.21,
    cy: 80.37,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.21,81.75a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,517.21,81.75Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,517.21,79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.2,
    cy: 91.11,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.2,92.5a1.39,1.39,0,1,1,1.39-1.39A1.38,1.38,0,0,1,507.2,92.5Zm0-2.72a1.34,1.34,0,1,0,1.34,1.33A1.33,1.33,0,0,0,507.2,89.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.54,
    cy: 100.52,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.54,101.9a1.39,1.39,0,1,1,1.39-1.38A1.39,1.39,0,0,1,497.54,101.9Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,497.54,99.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.23,
    cy: 79.69,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.23,81.07a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,487.23,81.07Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.33,1.33,0,0,0,487.23,78.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.98,
    cy: 111.74,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,113.12a1.39,1.39,0,1,1,1.38-1.38A1.38,1.38,0,0,1,477,113.12Zm0-2.72a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,477,110.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.07,70.37s0,.34,0,1,0,1.58,0,2.78c0,2.45,0,6,.06,10.54,0,9.06.06,22,.11,37.58l-.22-.22L314,122h0l-.26.26c0-18.83,0-36.57,0-51.87l.23.23-43.3-.12-12.25-.06-3.26,0h-1.13a1.39,1.39,0,0,1,.27,0h.81l3.21,0,12.2-.06L314,70.14h.24v.23c0,15.3,0,33,0,51.87v.26H314l-59.94,0h-.22v-.22c.05-15.64.09-28.62.11-37.72,0-4.51,0-8,.06-10.49,0-1.18,0-2.1,0-2.74S254.07,70.37,254.07,70.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.57,76c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S304.43,76,304.57,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5,76c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S294.35,76,294.5,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.42,76c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S284.28,76,284.42,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.35,76c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S274.2,76,274.35,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.27,76c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S264.13,76,264.27,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.51,
    cy: 80.37,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.51,81.75a1.39,1.39,0,1,1,1.38-1.38A1.38,1.38,0,0,1,304.51,81.75Zm0-2.72a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,304.51,79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 91.11,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5,92.5a1.39,1.39,0,1,1,1.38-1.39A1.39,1.39,0,0,1,294.5,92.5Zm0-2.72a1.34,1.34,0,1,0,1.33,1.33A1.34,1.34,0,0,0,294.5,89.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.84,
    cy: 100.52,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,101.9a1.39,1.39,0,1,1,1.38-1.38A1.38,1.38,0,0,1,284.84,101.9Zm0-2.72a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,284.84,99.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.53,
    cy: 79.69,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.53,81.07a1.39,1.39,0,1,1,1.38-1.38A1.38,1.38,0,0,1,274.53,81.07Zm0-2.72a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,274.53,78.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.27,
    cy: 111.74,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.27,113.12a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,264.27,113.12Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,264.27,110.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.45,
    cy: 114.65,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.21,
    cy: 114.65,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,114.65A1.39,1.39,0,1,1,373,116,1.38,1.38,0,0,1,371.58,114.65Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.72,
    cy: 114.65,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 114.65,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.85,114.65a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,343.85,114.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.99,
    cy: 114.65,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.75,
    cy: 114.65,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.45,
    cy: 105.81,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.21,
    cy: 105.81,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,105.81A1.39,1.39,0,1,1,373,107.2,1.38,1.38,0,0,1,371.58,105.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.72,
    cy: 105.81,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 105.81,
    r: 1.38,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.85,105.81a1.39,1.39,0,1,1,1.38,1.39A1.38,1.38,0,0,1,343.85,105.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.99,
    cy: 105.81,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.75,
    cy: 105.81,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.45,
    cy: 96.98,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.21,
    cy: 96.98,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,97A1.39,1.39,0,1,1,373,98.36,1.38,1.38,0,0,1,371.58,97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.72,
    cy: 96.98,
    r: 1.38,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 96.98,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.85,97a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,343.85,97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.99,
    cy: 96.98,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.75,
    cy: 96.98,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.07,88.14a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,390.07,88.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.82,88.14a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,380.82,88.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,88.14A1.39,1.39,0,1,1,373,89.52,1.38,1.38,0,0,1,371.58,88.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,88.14a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,362.34,88.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.09,88.14a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,353.09,88.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.85,88.14a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,343.85,88.14Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.6,88.14A1.39,1.39,0,1,1,336,89.52,1.39,1.39,0,0,1,334.6,88.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.36,88.14a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,325.36,88.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.07,79.3a1.39,1.39,0,1,1,1.38,1.39A1.38,1.38,0,0,1,390.07,79.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.82,79.3a1.39,1.39,0,1,1,1.39,1.39A1.38,1.38,0,0,1,380.82,79.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,79.3A1.39,1.39,0,1,1,373,80.69,1.38,1.38,0,0,1,371.58,79.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,79.3a1.39,1.39,0,1,1,1.38,1.39A1.38,1.38,0,0,1,362.34,79.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.09,79.3a1.39,1.39,0,1,1,1.39,1.39A1.38,1.38,0,0,1,353.09,79.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.85,79.3a1.39,1.39,0,1,1,1.38,1.39A1.38,1.38,0,0,1,343.85,79.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.6,79.3A1.39,1.39,0,1,1,336,80.69,1.38,1.38,0,0,1,334.6,79.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.36,79.3a1.39,1.39,0,1,1,1.39,1.39A1.38,1.38,0,0,1,325.36,79.3Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.47,
    y: 114.65,
    width: 7.59,
    height: 7.59,
    transform: "translate(490.54 236.89) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,122.26h-7.64v-7.64h7.64Zm-7.59-.05H249v-7.54H241.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.47,
    y: 104.22,
    width: 7.59,
    height: 7.59,
    transform: "translate(490.54 216.04) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,111.84h-7.64V104.2h7.64Zm-7.59,0H249v-7.54H241.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.47,
    y: 93.8,
    width: 7.59,
    height: 7.59,
    transform: "translate(490.54 195.19) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,101.42h-7.64V93.77h7.64Zm-7.59,0H249V93.82H241.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.47,
    y: 83.38,
    width: 7.59,
    height: 7.59,
    transform: "translate(490.54 174.34) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,91h-7.64V83.35h7.64Zm-7.59,0H249V83.4H241.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.47,
    y: 72.95,
    width: 7.59,
    height: 7.59,
    transform: "translate(490.54 153.49) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,80.57h-7.64V72.93h7.64Zm-7.59,0H249V73H241.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.62,
    y: 71.14,
    width: 44.01,
    height: 51.1,
    transform: "translate(429.25 193.38) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.65,122.26H192.59V71.11h44.06Zm-44-.05h44v-51h-44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.22 319.9 180.28 288.45 569.8 288.45 584.52 319.9 164.22 319.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.48,314.26c-.28,0-1.29-4.4-2.26-9.94s-1.53-10.06-1.24-10.11,1.29,4.4,2.26,9.93S312.77,314.21,312.48,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.09,291.07a4,4,0,0,1,.47,0l1.45,0,5.69,0,22-.08,81.57-.16,273.81-.19h.33l.14.3,11.88,25.58.34.74H566c-182,0-337.36-.14-397.35-.34h-.31l.15-.27,10.17-19.11q1.73-3.18,2.58-4.8l.66-1.19c.15-.27.23-.39.23-.39l-.21.43-.62,1.23c-.57,1.09-1.4,2.72-2.52,4.87l-10,19.14-.16-.28c60-.19,215.33-.33,397.35-.33h13l-.47.74-11.88-25.58.47.3-273.54-.2-81.66-.15-22.09-.09-5.74,0-1.47,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.68,
    y1: 293.1,
    x2: 191.55,
    y2: 314.26,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.55,314.26c-.27-.12,1.56-4.95,4.09-10.79s4.78-10.48,5-10.37-1.56,4.94-4.09,10.79S191.81,314.37,191.55,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.11,
    cy: 303.05,
    r: 2.54,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.51,314.26c-.28-.08.76-4.88,2.33-10.72s3.06-10.51,3.34-10.44-.77,4.87-2.33,10.71S203.79,314.33,203.51,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.27,314.26c-.28-.07.51-4.85,1.77-10.69s2.51-10.53,2.79-10.47-.51,4.85-1.77,10.69S213.55,314.32,213.27,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.54,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.05,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.52,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.99,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.12,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.54,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.05,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.52,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.99,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.12,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.81,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.32,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.79,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.25,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.18,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.63,
    y: 302.1,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.1,314.26c-.28,0-1.29-4.4-2.26-9.94s-1.53-10.06-1.24-10.11,1.29,4.4,2.26,9.93S280.39,314.21,280.1,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.2,314.26c-.28,0-1.3-4.4-2.27-9.94s-1.52-10.06-1.24-10.11,1.3,4.4,2.27,9.93S288.48,314.21,288.2,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.29,314.26c-.28,0-1.29-4.4-2.26-9.94s-1.53-10.06-1.24-10.11,1.3,4.4,2.26,9.93S296.58,314.21,296.29,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.39,314.26c-.28,0-1.3-4.4-2.27-9.94s-1.52-10.06-1.24-10.11,1.3,4.4,2.27,9.93S304.67,314.21,304.39,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.58,314.26c-.28,0-1.3-4.4-2.27-9.94s-1.52-10.06-1.24-10.11,1.3,4.4,2.27,9.93S320.86,314.21,320.58,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,312.58a2.54,2.54,0,1,1,0-3.59A2.52,2.52,0,0,1,206,312.58Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.95,
    cy: 297.21,
    r: 2.54,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.39,299.63a2.54,2.54,0,1,1,0-3.59A2.52,2.52,0,0,1,278.39,299.63Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.21,307.08a2.54,2.54,0,1,1,0-3.6A2.54,2.54,0,0,1,288.21,307.08Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,311.26a2.54,2.54,0,1,1,0-3.59A2.52,2.52,0,0,1,297,311.26Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.1,300.17a2.54,2.54,0,1,1,0-3.59A2.54,2.54,0,0,1,303.1,300.17Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.12,312a2.54,2.54,0,1,1,0-3.59A2.54,2.54,0,0,1,313.12,312Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.68,300.62a2.54,2.54,0,1,1,0-3.59A2.54,2.54,0,0,1,319.68,300.62Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 549.56,
    y1: 293.1,
    x2: 558.7,
    y2: 314.26,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.7,314.25c-.27.12-2.53-4.52-5.05-10.36s-4.36-10.67-4.09-10.79,2.52,4.53,5.05,10.37S559,314.14,558.7,314.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.13,
    cy: 303.05,
    r: 2.54,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.73,314.26c-.27.07-1.77-4.61-3.33-10.45s-2.61-10.63-2.33-10.71,1.77,4.6,3.33,10.44S547,314.18,546.73,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537,314.26c-.28.06-1.53-4.63-2.79-10.47s-2-10.63-1.77-10.69,1.53,4.63,2.79,10.47S537.25,314.19,537,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520.43,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    transform: "translate(1045.13 592.69) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.92,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    transform: "translate(1026.11 592.69) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.46,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    transform: "translate(1007.18 592.69) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.99,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    transform: "translate(988.25 592.69) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.86,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    transform: "translate(967.98 592.69) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520.43,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    transform: "translate(1045.13 621.58) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.92,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    transform: "translate(1026.11 621.58) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.46,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    transform: "translate(1007.18 621.58) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.99,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    transform: "translate(988.25 621.58) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.86,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    transform: "translate(967.98 621.58) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.17,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    transform: "translate(1052.6 608.35) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 514.66,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    transform: "translate(1033.58 608.35) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.19,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    transform: "translate(1014.65 608.35) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.72,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    transform: "translate(995.71 608.35) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.8,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    transform: "translate(957.86 608.35) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.34,
    y: 302.1,
    width: 4.27,
    height: 4.27,
    transform: "translate(974.95 608.47) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.14,314.26c-.28-.05.27-4.58,1.24-10.12s2-10,2.27-9.93-.28,4.58-1.25,10.11S470.42,314.3,470.14,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,314.26c-.28-.05.28-4.58,1.24-10.12s2-10,2.27-9.93-.27,4.58-1.24,10.11S462.33,314.3,462,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,314.26c-.28-.05.27-4.58,1.24-10.12s2-10,2.27-9.93-.28,4.58-1.25,10.11S454.23,314.3,454,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.85,314.26c-.28-.05.28-4.58,1.24-10.12s2-10,2.27-9.93-.27,4.58-1.24,10.11S446.14,314.3,445.85,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.66,314.26c-.28-.05.28-4.58,1.24-10.12s2-10,2.27-9.93-.27,4.58-1.24,10.11S430,314.3,429.66,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.21,312.58a2.54,2.54,0,1,0,0-3.59A2.52,2.52,0,0,0,544.21,312.58Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.3,
    cy: 297.21,
    r: 2.54,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.85,299.63a2.54,2.54,0,1,0,0-3.59A2.52,2.52,0,0,0,471.85,299.63Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.82,
    cy: 305.28,
    r: 2.54,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.22,311.26a2.54,2.54,0,1,0,0-3.59A2.52,2.52,0,0,0,453.22,311.26Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.15,300.17a2.54,2.54,0,1,0,0-3.59A2.54,2.54,0,0,0,447.15,300.17Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.13,312a2.54,2.54,0,1,0,0-3.59A2.54,2.54,0,0,0,437.13,312Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.57,300.62a2.54,2.54,0,1,0,0-3.59A2.52,2.52,0,0,0,430.57,300.62Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "180.28 337.83 180.28 466.12 196.11 466.12 196.11 337.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "554.23 337.83 554.23 466.12 570.07 466.12 570.07 337.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.13,335.42a.94.94,0,0,1-.09.26l-.31.75c-.15.34-.33.74-.53,1.21a15.72,15.72,0,0,1-.79,1.62,44.35,44.35,0,0,1-6.58,9.42c-.77.94-1.73,1.79-2.67,2.73s-2,1.79-3.12,2.72-2.3,1.79-3.61,2.58c-.65.4-1.29.84-2,1.24l-2.1,1.14a45.1,45.1,0,0,1-40.42,1l-2.15-1c-.69-.37-1.35-.77-2-1.15-1.35-.72-2.53-1.62-3.73-2.39s-2.26-1.69-3.26-2.56-2-1.7-2.8-2.6a44.56,44.56,0,0,1-7-9.08,17.76,17.76,0,0,1-.87-1.58l-.58-1.19c-.15-.3-.26-.54-.36-.73a1.16,1.16,0,0,1-.1-.26,1.23,1.23,0,0,1,.15.24c.11.18.24.41.4.7l.63,1.16a15.31,15.31,0,0,0,.91,1.55,45.92,45.92,0,0,0,7.11,8.93c.82.89,1.83,1.67,2.8,2.55s2.12,1.66,3.25,2.51,2.37,1.65,3.71,2.36c.66.36,1.32.76,2,1.12l2.13,1a47.16,47.16,0,0,0,9.46,3.19,42.8,42.8,0,0,0,21.25-.52,47.41,47.41,0,0,0,9.29-3.65l2.08-1.13c.67-.39,1.31-.82,1.95-1.22,1.3-.77,2.43-1.71,3.59-2.53s2.16-1.77,3.12-2.67,1.89-1.76,2.67-2.69a45.79,45.79,0,0,0,6.67-9.26,15.57,15.57,0,0,0,.83-1.6l.57-1.18.36-.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.07,334.63a1.48,1.48,0,0,1-.08.3l-.28.84q-.19.59-.48,1.38a14.31,14.31,0,0,1-.73,1.85l-1,2.26c-.41.82-.93,1.67-1.44,2.6s-1.19,1.85-1.85,2.86a34.62,34.62,0,0,1-2.32,3c-.8,1.07-1.83,2-2.82,3.12a21.68,21.68,0,0,1-1.62,1.54c-.56.5-1.12,1-1.73,1.55l-1.9,1.47c-.32.25-.64.52-1,.75l-1.05.69c-.7.46-1.4.95-2.13,1.4l-2.3,1.29c-.76.46-1.59.79-2.41,1.18a27.21,27.21,0,0,1-2.53,1.1l-2.64,1-2.76.78a42.05,42.05,0,0,1-23.6-.56l-2.73-.91L475.08,363a26.89,26.89,0,0,1-2.47-1.21,24.46,24.46,0,0,1-2.36-1.3L468,359.13c-.72-.48-1.39-1-2.08-1.5l-1-.74c-.33-.25-.63-.53-.95-.79l-1.82-1.57c-.58-.53-1.11-1.09-1.66-1.63a21.08,21.08,0,0,1-1.54-1.61c-.94-1.13-1.92-2.14-2.67-3.25a33,33,0,0,1-2.17-3.15,30.74,30.74,0,0,1-1.71-2.94c-.47-1-.95-1.83-1.32-2.66s-.64-1.62-.92-2.31a15.18,15.18,0,0,1-.65-1.88c-.16-.55-.29-1-.41-1.4s-.17-.64-.24-.86a1.18,1.18,0,0,1-.06-.3,1,1,0,0,1,.11.28c.08.22.17.5.29.85l.46,1.38a15.11,15.11,0,0,0,.69,1.85l1,2.29c.38.82.87,1.68,1.34,2.62s1.12,1.88,1.74,2.9a34.65,34.65,0,0,0,2.18,3.1c.75,1.1,1.74,2.1,2.67,3.21.46.56,1,1.05,1.55,1.59s1.07,1.08,1.65,1.6l1.82,1.55c.31.25.61.53.93.78l1,.73c.68.48,1.34,1,2.06,1.47l2.21,1.37a25,25,0,0,0,2.34,1.28c.8.4,1.59.86,2.45,1.19l2.56,1.09,2.7.89a41.67,41.67,0,0,0,23.32.55l2.74-.76,2.61-1a54.79,54.79,0,0,0,4.9-2.24l2.27-1.26c.74-.44,1.43-.92,2.13-1.37l1-.68c.34-.24.66-.5,1-.74l1.89-1.45c.6-.5,1.16-1,1.72-1.53a21.36,21.36,0,0,0,1.62-1.52c1-1.06,2-2,2.82-3.07a34.82,34.82,0,0,0,2.33-3c.67-1,1.37-1.89,1.87-2.82s1.05-1.76,1.46-2.56l1.07-2.23a15,15,0,0,0,.78-1.82c.2-.53.38-1,.52-1.36s.25-.62.33-.83A1.47,1.47,0,0,1,537.07,334.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.14,336.36s.18.21.5.63.81,1.07,1.41,1.92a56,56,0,0,1,4.53,7.95,57.74,57.74,0,0,1,4.32,13.8,61.2,61.2,0,0,1,.84,9,56.08,56.08,0,0,1-.83,10.11,54.24,54.24,0,0,1-8.86,21.37,56,56,0,0,1-19.77,17.67,49.09,49.09,0,0,1-13.64,4.73,39,39,0,0,1-15-.05,32.72,32.72,0,0,1-7.37-2.45,30.24,30.24,0,0,1-6.58-4.37,28.93,28.93,0,0,1-8.83-13.32,23.56,23.56,0,0,1-1-8.07,19.78,19.78,0,0,1,2-7.77,16.39,16.39,0,0,1,5-6.14,12.5,12.5,0,0,1,7.35-2.47,12,12,0,0,1,7.29,2.22A9.6,9.6,0,0,1,529,384a10.08,10.08,0,0,1,1.22,3.58,12,12,0,0,1-1.52,7.17,14.49,14.49,0,0,1-4.87,5.26,15.18,15.18,0,0,1-6.67,2.14,20.82,20.82,0,0,1-6.79-.56,32.88,32.88,0,0,1-11.65-5.63,44.81,44.81,0,0,1-4.73-4,44.33,44.33,0,0,1-4-4.44,43.53,43.53,0,0,1-5.74-9.57,42.34,42.34,0,0,1-3.63-18.73A44.58,44.58,0,0,1,483.51,345a41.59,41.59,0,0,1,4.1-8.17c.55-.9,1-1.52,1.35-2s.49-.65.49-.65-.14.24-.44.68-.78,1.08-1.31,2a43.27,43.27,0,0,0-4,8.19,43.44,43.44,0,0,0,.95,32.67,43.67,43.67,0,0,0,5.72,9.48,46,46,0,0,0,3.94,4.38,43.74,43.74,0,0,0,4.69,3.93,32.64,32.64,0,0,0,11.51,5.54,20.22,20.22,0,0,0,6.64.53,14.63,14.63,0,0,0,6.45-2.07,14.11,14.11,0,0,0,4.7-5.09,11.59,11.59,0,0,0,1.46-6.87,9.75,9.75,0,0,0-1.16-3.39,9,9,0,0,0-2.45-2.66,11.46,11.46,0,0,0-7-2.12,12,12,0,0,0-7.06,2.37,16,16,0,0,0-4.81,5.95,19.38,19.38,0,0,0-1.92,7.58,23,23,0,0,0,.94,7.89A28.37,28.37,0,0,0,515,416.3a30.41,30.41,0,0,0,6.46,4.3A32.66,32.66,0,0,0,528.7,423a38.46,38.46,0,0,0,14.85.06,48.25,48.25,0,0,0,13.51-4.67,55.73,55.73,0,0,0,19.64-17.48,54.05,54.05,0,0,0,8.84-21.2,55.34,55.34,0,0,0,.87-10,62.19,62.19,0,0,0-.8-9,58.54,58.54,0,0,0-4.21-13.77,59.18,59.18,0,0,0-4.43-8c-.6-.85-1.06-1.49-1.37-1.94S575.14,336.36,575.14,336.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,326.43s-.8,4.62-3.13,12.77a144.14,144.14,0,0,1-5.06,14.59A113.62,113.62,0,0,1,389.44,372a89.2,89.2,0,0,1-16.08,18.81,73.11,73.11,0,0,1-24.45,14.34,59.45,59.45,0,0,1-15.09,3,56.89,56.89,0,0,1-16-1.22,55.17,55.17,0,0,1-15.48-6.05,45.55,45.55,0,0,1-12.93-11.19,35.54,35.54,0,0,1-4.58-7.35,30.65,30.65,0,0,1-2.53-8.16,23.12,23.12,0,0,1,.2-8.42,17.8,17.8,0,0,1,3.61-7.45,19.18,19.18,0,0,1,6.41-5,15,15,0,0,1,7.86-1.39,12.71,12.71,0,0,1,7.06,3.32,15.56,15.56,0,0,1,3.93,6.56,16.48,16.48,0,0,1-2,14.19A20.6,20.6,0,0,1,298,383.68a24.68,24.68,0,0,1-12.84.2A33.86,33.86,0,0,1,274.37,379a53.66,53.66,0,0,1-14.16-14.65,60.68,60.68,0,0,1-6.83-13.82A56.53,56.53,0,0,1,251,341c-.37-2.2-.46-3.37-.46-3.37s.06.29.15.85.19,1.41.41,2.5a60.33,60.33,0,0,0,2.51,9.4,61.54,61.54,0,0,0,6.88,13.73,53.55,53.55,0,0,0,14.12,14.51,33.45,33.45,0,0,0,10.72,4.83,24.38,24.38,0,0,0,12.62-.22,20.25,20.25,0,0,0,11-7.58,16.07,16.07,0,0,0,2-13.79,15.21,15.21,0,0,0-3.81-6.34,12.24,12.24,0,0,0-6.79-3.18,14.41,14.41,0,0,0-7.58,1.35,18.57,18.57,0,0,0-6.23,4.89,17.29,17.29,0,0,0-3.51,7.24,22.53,22.53,0,0,0-.19,8.23,29.51,29.51,0,0,0,2.5,8,33.83,33.83,0,0,0,4.51,7.24,45,45,0,0,0,12.78,11.07,54.71,54.71,0,0,0,15.34,6,56.92,56.92,0,0,0,15.86,1.21,59.11,59.11,0,0,0,15-3,72.73,72.73,0,0,0,24.31-14.2,89.17,89.17,0,0,0,16.06-18.69,115.15,115.15,0,0,0,9.41-18.07,146.14,146.14,0,0,0,5.13-14.53c1.22-4.06,2-7.26,2.53-9.42.25-1.07.45-1.9.58-2.47S407,326.43,407,326.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.42,
    y: 319.9,
    width: 420.31,
    height: 17.93,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.48,287.78c.7-6.5,0-235,0-235H568.67V291.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.9,206.6c0-1,0-23.48-.14-65.23l.14.13-370.5.13h0l.26-.26V206.6l-.26-.26,370.52.26-370.52.25h-.25v-.25c0-20.94,0-42.89,0-65.23v-.26h.28l370.5.12H558v.14C558,183.12,557.9,205.6,557.9,206.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.03,
    y: 147.36,
    width: 19.44,
    height: 51.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.35,199.23s0-.33,0-.95,0-1.55,0-2.74c0-2.4,0-5.92-.05-10.41,0-9-.06-21.95-.11-37.77l.21.2-82.32.06h0l.26-.26c0,18.39,0,35.92,0,51.87L345,199l59.22.12,17,.06,4.53,0h1.18l.41,0H427l-1.15,0-4.48,0-16.94.06-59.37.12h-.24v-.24c0-15.95,0-33.48,0-51.87v-.26H345l82.32.05h.2v.21c0,15.87-.08,28.86-.11,37.89,0,4.48,0,8-.05,10.38,0,1.17,0,2.07,0,2.69S427.35,199.23,427.35,199.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.83,
    y: 149.27,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.45,157.88h-8.64v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.53,
    y: 149.27,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.14,157.88H300.5v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.23,
    y: 149.27,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84,157.88H314.2v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.92,
    y: 149.27,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.54,157.88H327.9v-8.64h8.64Zm-8.59,0h8.54v-8.54H328Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.83,
    y: 162.62,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.45,171.23h-8.64v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.53,
    y: 162.62,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.14,171.23H300.5v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.23,
    y: 162.62,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84,171.23H314.2v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.92,
    y: 162.62,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.54,171.23H327.9v-8.64h8.64Zm-8.59,0h8.54v-8.54H328Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.83,
    y: 175.97,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.45,184.58h-8.64v-8.64h8.64Zm-8.59-.05h8.54V176h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.53,
    y: 175.97,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.14,184.58H300.5v-8.64h8.64Zm-8.59-.05h8.54V176h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.23,
    y: 175.97,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84,184.58H314.2v-8.64h8.64Zm-8.59-.05h8.54V176h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.92,
    y: 175.97,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.54,184.58H327.9v-8.64h8.64Zm-8.59-.05h8.54V176H328Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.83,
    y: 189.31,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.45,197.93h-8.64v-8.64h8.64Zm-8.59-.05h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.53,
    y: 189.31,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.14,197.93H300.5v-8.64h8.64Zm-8.59-.05h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.23,
    y: 189.31,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84,197.93H314.2v-8.64h8.64Zm-8.59-.05h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.92,
    y: 189.31,
    width: 8.59,
    height: 8.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.54,197.93H327.9v-8.64h8.64Zm-8.59-.05h8.54v-8.54H328Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.31,199.23s0-.34,0-1,0-1.58,0-2.79c0-2.45,0-6-.06-10.53,0-9.07-.07-22-.11-37.58l.22.22-59.94,0h0l.26-.26c0,18.83,0,36.57,0,51.87l-.23-.23,43.31.11,12.25.07,3.25,0,.84,0h0l-.82,0-3.2,0-12.2.06-43.46.12h-.23v-.23c0-15.3,0-33,0-51.87v-.26h.27l59.94,0h.22v.22c0,15.63-.09,28.62-.12,37.72,0,4.5,0,8-.05,10.48,0,1.19,0,2.1,0,2.75S279.31,199.23,279.31,199.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.8,193.61c-.14,0-.26-9-.26-20s.12-20,.26-20,.26,9,.26,20S229,193.61,228.8,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.88,193.61c-.14,0-.26-9-.26-20s.12-20,.26-20,.26,9,.26,20S239,193.61,238.88,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,193.61c-.14,0-.26-9-.26-20s.12-20,.26-20,.26,9,.26,20S249.1,193.61,249,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,193.61c-.15,0-.26-9-.26-20s.11-20,.26-20,.26,9,.26,20S259.17,193.61,259,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.1,193.61c-.14,0-.26-9-.26-20s.12-20,.26-20,.26,9,.26,20S269.25,193.61,269.1,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.23,189.23a1.36,1.36,0,1,1-1.36-1.36A1.36,1.36,0,0,1,230.23,189.23Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.87,190.61a1.39,1.39,0,1,1,1.38-1.38A1.38,1.38,0,0,1,228.87,190.61Zm0-2.72a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,228.87,187.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.88,
    cy: 178.48,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.88,179.87a1.39,1.39,0,1,1,1.38-1.39A1.39,1.39,0,0,1,238.88,179.87Zm0-2.72a1.34,1.34,0,1,0,1.33,1.33A1.33,1.33,0,0,0,238.88,177.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9,169.08a1.36,1.36,0,1,1-1.36-1.36A1.36,1.36,0,0,1,249.9,169.08Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.54,170.47a1.39,1.39,0,1,1,1.39-1.39A1.4,1.4,0,0,1,248.54,170.47Zm0-2.73a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,248.54,167.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.85,
    cy: 189.91,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.85,191.3a1.39,1.39,0,1,1,1.38-1.39A1.39,1.39,0,0,1,258.85,191.3Zm0-2.73a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,258.85,188.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.1,
    cy: 157.86,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.1,159.24a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,269.1,159.24Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,269.1,156.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,199.23s0-.34,0-1,0-1.58,0-2.79c0-2.45,0-6-.06-10.53,0-9.07-.06-22-.11-37.58l.22.22-59.94,0h0l.26-.26c0,18.83,0,36.57,0,51.87l-.23-.23,43.3.11,12.25.07,3.26,0,.84,0h0l-.81,0-3.21,0-12.2.06-43.45.12h-.23v-.23c0-15.3,0-33,0-51.87v-.26h.27l59.94,0h.22v.22c-.05,15.63-.09,28.62-.11,37.72,0,4.5-.05,8-.06,10.48,0,1.19,0,2.1,0,2.75S492,199.23,492,199.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.51,193.61c-.15,0-.26-9-.26-20s.11-20,.26-20,.26,9,.26,20S441.65,193.61,441.51,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.58,193.61c-.14,0-.26-9-.26-20s.12-20,.26-20,.26,9,.26,20S451.73,193.61,451.58,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.66,193.61c-.15,0-.26-9-.26-20s.11-20,.26-20,.26,9,.26,20S461.8,193.61,461.66,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.73,193.61c-.14,0-.26-9-.26-20s.12-20,.26-20,.26,9,.26,20S471.88,193.61,471.73,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.81,193.61c-.15,0-.26-9-.26-20s.11-20,.26-20,.26,9,.26,20S482,193.61,481.81,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.57,
    cy: 189.23,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.57,190.61a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,441.57,190.61Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.33,1.33,0,0,0,441.57,187.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.58,
    cy: 178.48,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.58,179.87a1.39,1.39,0,1,1,1.39-1.39A1.38,1.38,0,0,1,451.58,179.87Zm0-2.72a1.34,1.34,0,1,0,1.34,1.33A1.33,1.33,0,0,0,451.58,177.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 461.24,
    cy: 169.08,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.24,170.47a1.39,1.39,0,1,1,1.39-1.39A1.39,1.39,0,0,1,461.24,170.47Zm0-2.73a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,461.24,167.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 471.55,
    cy: 189.91,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.55,191.3a1.39,1.39,0,1,1,1.39-1.39A1.39,1.39,0,0,1,471.55,191.3Zm0-2.73a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,471.55,188.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.81,
    cy: 157.86,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.81,159.24a1.39,1.39,0,1,1,1.38-1.38A1.38,1.38,0,0,1,481.81,159.24Zm0-2.72a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,481.81,156.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,155a1.39,1.39,0,1,1-1.38-1.39A1.38,1.38,0,0,1,356,155Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.87,
    cy: 154.95,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.12,
    cy: 154.95,
    r: 1.38,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.74,155a1.38,1.38,0,1,1-1.38-1.39A1.38,1.38,0,0,1,383.74,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.6,
    cy: 154.95,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.85,
    cy: 154.95,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.48,155a1.39,1.39,0,1,1-1.39-1.39A1.38,1.38,0,0,1,411.48,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.34,
    cy: 154.95,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,163.78a1.39,1.39,0,1,1-1.38-1.38A1.38,1.38,0,0,1,356,163.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.87,
    cy: 163.78,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.12,
    cy: 163.78,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.74,163.78a1.38,1.38,0,1,1-1.38-1.38A1.38,1.38,0,0,1,383.74,163.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.6,
    cy: 163.78,
    r: 1.38,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.85,
    cy: 163.78,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.48,163.78a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,411.48,163.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.34,
    cy: 163.78,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,172.62a1.39,1.39,0,1,1-1.38-1.38A1.38,1.38,0,0,1,356,172.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.87,
    cy: 172.62,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.12,
    cy: 172.62,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.74,172.62a1.38,1.38,0,1,1-1.38-1.38A1.38,1.38,0,0,1,383.74,172.62Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.6,
    cy: 172.62,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.85,
    cy: 172.62,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.48,172.62a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,411.48,172.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.34,
    cy: 172.62,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,181.46a1.39,1.39,0,1,1-1.38-1.39A1.38,1.38,0,0,1,356,181.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.26,181.46a1.39,1.39,0,1,1-1.39-1.39A1.38,1.38,0,0,1,365.26,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.5,181.46a1.39,1.39,0,1,1-1.38-1.39A1.38,1.38,0,0,1,374.5,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.74,181.46a1.38,1.38,0,1,1-1.38-1.39A1.38,1.38,0,0,1,383.74,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,181.46a1.39,1.39,0,1,1-1.39-1.39A1.38,1.38,0,0,1,393,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.23,181.46a1.39,1.39,0,1,1-1.38-1.39A1.38,1.38,0,0,1,402.23,181.46Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.48,181.46a1.39,1.39,0,1,1-1.39-1.39A1.38,1.38,0,0,1,411.48,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.72,181.46a1.39,1.39,0,1,1-1.38-1.39A1.38,1.38,0,0,1,420.72,181.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,190.29a1.39,1.39,0,1,1-1.38-1.38A1.38,1.38,0,0,1,356,190.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.26,190.29a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,365.26,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.5,190.29a1.39,1.39,0,1,1-1.38-1.38A1.38,1.38,0,0,1,374.5,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.74,190.29a1.38,1.38,0,1,1-1.38-1.38A1.38,1.38,0,0,1,383.74,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,190.29a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,393,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.23,190.29a1.39,1.39,0,1,1-1.38-1.38A1.38,1.38,0,0,1,402.23,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.48,190.29a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,411.48,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.72,190.29a1.39,1.39,0,1,1-1.38-1.38A1.38,1.38,0,0,1,420.72,190.29Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.02,
    y: 147.36,
    width: 7.59,
    height: 7.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.63,155H497v-7.64h7.64Zm-7.59-.05h7.54v-7.54H497Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.02,
    y: 157.78,
    width: 7.59,
    height: 7.59,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.63,165.4H497v-7.64h7.64Zm-7.59-.05h7.54v-7.54H497Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.02,
    y: 168.2,
    width: 7.59,
    height: 7.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.63,175.82H497v-7.64h7.64Zm-7.59,0h7.54v-7.54H497Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.02,
    y: 178.63,
    width: 7.59,
    height: 7.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.63,186.24H497V178.6h7.64Zm-7.59,0h7.54v-7.55H497Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.02,
    y: 189.05,
    width: 7.59,
    height: 7.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.63,196.67H497V189h7.64Zm-7.59,0h7.54v-7.54H497Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.45,
    y: 147.36,
    width: 44.01,
    height: 51.1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.49,198.48H509.43V147.33h44.06Zm-44,0h44V147.38h-44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.38,213.88c0,1,.05,23.48.14,65.23l-.14-.13,370.5-.13h0l-.26.26V213.88l.26.26-370.52-.26,370.52-.25h.26v65.74h-.28l-370.5-.12h-.13v-.14C187.33,237.36,187.38,214.88,187.38,213.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.81,
    y: 221.25,
    width: 19.44,
    height: 51.87,
    transform: "translate(1085.06 494.37) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.94,221.25s0,.33,0,.95,0,1.55,0,2.74c0,2.4,0,5.92,0,10.41,0,9,.07,22,.11,37.77l-.2-.2,82.31-.06h0l-.26.26c0-18.39,0-35.92,0-51.87l.24.24L341,221.37l-17-.06-4.53,0-1.18,0h0l1.14,0,4.48,0,16.94-.06,59.37-.12h.24v.24c0,15.95,0,33.48,0,51.87v.26h-.26l-82.31-.05h-.21v-.21c0-15.87.08-28.86.11-37.89,0-4.48,0-8,.05-10.38,0-1.17,0-2.07,0-2.69S317.94,221.25,317.94,221.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.86,
    y: 262.62,
    width: 8.59,
    height: 8.59,
    transform: "translate(908.31 533.83) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.48,271.24h-8.64V262.6h8.64Zm-8.59-.05h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 262.62,
    width: 8.59,
    height: 8.59,
    transform: "translate(880.92 533.83) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.78,271.24h-8.64V262.6h8.64Zm-8.59-.05h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.47,
    y: 262.62,
    width: 8.59,
    height: 8.59,
    transform: "translate(853.52 533.83) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.08,271.24h-8.64V262.6h8.64Zm-8.59-.05H431v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 262.62,
    width: 8.59,
    height: 8.59,
    transform: "translate(826.13 533.83) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.39,271.24h-8.65V262.6h8.65Zm-8.59-.05h8.53v-8.54H408.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.86,
    y: 249.27,
    width: 8.59,
    height: 8.59,
    transform: "translate(908.31 507.14) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.48,257.89h-8.64v-8.64h8.64Zm-8.59-.05h8.54V249.3h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 249.27,
    width: 8.59,
    height: 8.59,
    transform: "translate(880.92 507.14) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.78,257.89h-8.64v-8.64h8.64Zm-8.59-.05h8.54V249.3h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.47,
    y: 249.27,
    width: 8.59,
    height: 8.59,
    transform: "translate(853.52 507.14) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.08,257.89h-8.64v-8.64h8.64Zm-8.59-.05H431V249.3h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 249.27,
    width: 8.59,
    height: 8.59,
    transform: "translate(826.13 507.14) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.39,257.89h-8.65v-8.64h8.65Zm-8.59-.05h8.53V249.3H408.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.86,
    y: 235.92,
    width: 8.59,
    height: 8.59,
    transform: "translate(908.31 480.44) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.48,244.54h-8.64V235.9h8.64Zm-8.59,0h8.54V236h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 235.92,
    width: 8.59,
    height: 8.59,
    transform: "translate(880.92 480.44) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.78,244.54h-8.64V235.9h8.64Zm-8.59,0h8.54V236h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.47,
    y: 235.92,
    width: 8.59,
    height: 8.59,
    transform: "translate(853.52 480.44) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.08,244.54h-8.64V235.9h8.64Zm-8.59,0H431V236h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 235.92,
    width: 8.59,
    height: 8.59,
    transform: "translate(826.13 480.44) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.39,244.54h-8.65V235.9h8.65Zm-8.59,0h8.53V236H408.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.86,
    y: 222.58,
    width: 8.59,
    height: 8.59,
    transform: "translate(908.31 453.74) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.48,231.19h-8.64v-8.64h8.64Zm-8.59-.05h8.54V222.6h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 222.58,
    width: 8.59,
    height: 8.59,
    transform: "translate(880.92 453.74) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.78,231.19h-8.64v-8.64h8.64Zm-8.59-.05h8.54V222.6h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.47,
    y: 222.58,
    width: 8.59,
    height: 8.59,
    transform: "translate(853.52 453.74) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.08,231.19h-8.64v-8.64h8.64Zm-8.59-.05H431V222.6h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 222.58,
    width: 8.59,
    height: 8.59,
    transform: "translate(826.13 453.74) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.39,231.19h-8.65v-8.64h8.65Zm-8.59-.05h8.53V222.6H408.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,221.25s0,.34,0,1,0,1.58,0,2.79c0,2.45,0,6,.05,10.53,0,9.07.07,22,.12,37.58l-.22-.22,59.94,0h0l-.26.26c0-18.83,0-36.57,0-51.87l.23.23-43.31-.11-12.25-.07-3.25,0-.84,0h0l.82,0,3.21,0,12.19-.06,43.46-.12h.23v.23c0,15.3,0,33,0,51.87v.26h-.26l-59.94,0h-.22v-.22c0-15.63.08-28.62.11-37.72,0-4.5,0-8.05.06-10.48,0-1.19,0-2.11,0-2.75S466,221.25,466,221.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.48,226.87c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S516.33,226.87,516.48,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.4,226.87c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S506.26,226.87,506.4,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.33,226.87c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S496.18,226.87,496.33,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.25,226.87c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S486.11,226.87,486.25,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.18,226.87c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S476,226.87,476.18,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.41,
    cy: 231.25,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.41,232.64a1.39,1.39,0,1,1,1.39-1.39A1.38,1.38,0,0,1,516.41,232.64Zm0-2.73a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,516.41,229.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.4,
    cy: 242,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.4,243.38a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,506.4,243.38Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,506.4,240.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.74,
    cy: 251.4,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.74,252.79a1.39,1.39,0,1,1,1.39-1.39A1.39,1.39,0,0,1,496.74,252.79Zm0-2.73a1.34,1.34,0,1,0,1.34,1.34A1.33,1.33,0,0,0,496.74,250.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.43,
    cy: 230.57,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.43,232a1.39,1.39,0,1,1,1.39-1.39A1.39,1.39,0,0,1,486.43,232Zm0-2.73a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,486.43,229.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.18,
    cy: 262.62,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.18,264a1.39,1.39,0,1,1,1.39-1.39A1.39,1.39,0,0,1,476.18,264Zm0-2.72a1.34,1.34,0,1,0,1.33,1.33A1.34,1.34,0,0,0,476.18,261.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.27,221.25s0,.34,0,1,0,1.58,0,2.79c0,2.45,0,6,.06,10.53,0,9.07.06,22,.11,37.58l-.22-.22,59.94,0h0l-.26.26c0-18.83,0-36.57,0-51.87l.23.23-43.31-.11-12.25-.07-3.25,0-.84,0h0l.81,0,3.21,0,12.2-.06,43.46-.12h.23v.23c0,15.3,0,33,0,51.87v.26h-.27l-59.94,0h-.22v-.22c0-15.63.09-28.62.12-37.72,0-4.5,0-8.05.05-10.48,0-1.19,0-2.11,0-2.75S253.27,221.25,253.27,221.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.77,226.87c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S303.63,226.87,303.77,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.7,226.87c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S293.55,226.87,293.7,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.62,226.87c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S283.48,226.87,283.62,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.55,226.87c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S273.41,226.87,273.55,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.47,226.87c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S263.33,226.87,263.47,226.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.71,
    cy: 231.25,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71,232.64a1.39,1.39,0,1,1,1.39-1.39A1.39,1.39,0,0,1,303.71,232.64Zm0-2.73a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,303.71,229.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.7,
    cy: 242,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.7,243.38a1.39,1.39,0,1,1,1.38-1.38A1.38,1.38,0,0,1,293.7,243.38Zm0-2.72a1.34,1.34,0,1,0,0,2.67,1.34,1.34,0,0,0,0-2.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.04,
    cy: 251.4,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,252.79a1.39,1.39,0,1,1,1.38-1.39A1.39,1.39,0,0,1,284,252.79Zm0-2.73a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,284,250.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.73,
    cy: 230.57,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.73,232a1.39,1.39,0,1,1,1.39-1.39A1.39,1.39,0,0,1,273.73,232Zm0-2.73a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,273.73,229.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.47,
    cy: 262.62,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.47,264a1.39,1.39,0,1,1,1.39-1.39A1.38,1.38,0,0,1,263.47,264Zm0-2.72a1.34,1.34,0,1,0,1.34,1.33A1.34,1.34,0,0,0,263.47,261.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.65,
    cy: 265.53,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,265.53a1.39,1.39,0,1,1,1.39,1.39A1.38,1.38,0,0,1,380,265.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.17,
    cy: 265.53,
    r: 1.38,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.92,
    cy: 265.53,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,265.53a1.39,1.39,0,1,1,1.39,1.39A1.38,1.38,0,0,1,352.29,265.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.43,
    cy: 265.53,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.19,
    cy: 265.53,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.95,
    cy: 265.53,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.27,256.7a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,389.27,256.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,256.7a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,380,256.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.78,256.7a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,370.78,256.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.54,256.7a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,361.54,256.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,256.7a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,352.29,256.7Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.05,256.7a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,343.05,256.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.81,256.7a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,333.81,256.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.56,256.7a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,324.56,256.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.27,247.86a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,389.27,247.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,247.86a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,380,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.78,247.86a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,370.78,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.54,247.86a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,361.54,247.86Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,247.86a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,352.29,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.05,247.86a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,343.05,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.81,247.86a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,333.81,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.56,247.86a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,324.56,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.65,
    cy: 239.02,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,239a1.39,1.39,0,1,1,1.39,1.39A1.38,1.38,0,0,1,380,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.17,
    cy: 239.02,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.92,
    cy: 239.02,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,239a1.39,1.39,0,1,1,1.39,1.39A1.38,1.38,0,0,1,352.29,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.43,
    cy: 239.02,
    r: 1.38,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.19,
    cy: 239.02,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.95,
    cy: 239.02,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.65,
    cy: 230.19,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,230.19a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,380,230.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.17,
    cy: 230.19,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.92,
    cy: 230.19,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,230.19a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,352.29,230.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.43,
    cy: 230.19,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.19,
    cy: 230.19,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.95,
    cy: 230.19,
    r: 1.38,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.68,
    y: 265.53,
    width: 7.59,
    height: 7.59,
    transform: "translate(488.94 538.66) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.29,273.15h-7.64v-7.64h7.64Zm-7.59,0h7.54v-7.54H240.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.68,
    y: 255.11,
    width: 7.59,
    height: 7.59,
    transform: "translate(488.94 517.81) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.29,262.72h-7.64v-7.64h7.64Zm-7.59-.05h7.54v-7.54H240.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.68,
    y: 244.68,
    width: 7.59,
    height: 7.59,
    transform: "translate(488.94 496.96) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.29,252.3h-7.64v-7.64h7.64Zm-7.59-.05h7.54v-7.54H240.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.68,
    y: 234.26,
    width: 7.59,
    height: 7.59,
    transform: "translate(488.94 476.11) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.29,241.88h-7.64v-7.65h7.64Zm-7.59,0h7.54v-7.55H240.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.68,
    y: 223.84,
    width: 7.59,
    height: 7.59,
    transform: "translate(488.94 455.26) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.29,231.45h-7.64v-7.64h7.64Zm-7.59,0h7.54v-7.54H240.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.82,
    y: 222.02,
    width: 44.01,
    height: 51.1,
    transform: "translate(427.65 495.14) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.85,273.15h-44V222h44Zm-44,0h44V222.05h-44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.38,63c0,1,.05,23.48.14,65.23l-.14-.14,370.5-.12h0l-.26.26V63l.26.26L187.38,63l370.52-.26h.26v65.75h-.28l-370.5-.13h-.13v-.13C187.33,86.48,187.38,64,187.38,63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.81,
    y: 70.37,
    width: 19.44,
    height: 51.87,
    transform: "translate(1085.06 192.61) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.94,70.37s0,.33,0,.95,0,1.54,0,2.73c0,2.41,0,5.92,0,10.42,0,9,.07,22,.11,37.77l-.2-.21,82.31,0h0l-.26.26c0-18.4,0-35.93,0-51.87l.24.24L341,70.49l-17-.07-4.53,0-1.18,0h-.4l.38,0h1.14l4.48,0,16.94-.07,59.37-.11h.24v.24c0,15.94,0,33.47,0,51.87v.26h-.26l-82.31-.06h-.21v-.2c0-15.88.08-28.86.11-37.9,0-4.48,0-8,.05-10.37,0-1.17,0-2.07,0-2.7S317.94,70.37,317.94,70.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.86,
    y: 111.74,
    width: 8.59,
    height: 8.59,
    transform: "translate(908.31 232.07) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.48,120.35h-8.64v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 111.74,
    width: 8.59,
    height: 8.59,
    transform: "translate(880.92 232.07) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.78,120.35h-8.64v-8.64h8.64Zm-8.59,0h8.54v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.47,
    y: 111.74,
    width: 8.59,
    height: 8.59,
    transform: "translate(853.52 232.07) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.08,120.35h-8.64v-8.64h8.64Zm-8.59,0H431v-8.54h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 111.74,
    width: 8.59,
    height: 8.59,
    transform: "translate(826.13 232.07) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.39,120.35h-8.65v-8.64h8.65Zm-8.59,0h8.53v-8.54H408.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.86,
    y: 98.39,
    width: 8.59,
    height: 8.59,
    transform: "translate(908.31 205.37) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.48,107h-8.64V98.36h8.64Zm-8.59,0h8.54V98.41h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 98.39,
    width: 8.59,
    height: 8.59,
    transform: "translate(880.92 205.37) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.78,107h-8.64V98.36h8.64Zm-8.59,0h8.54V98.41h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.47,
    y: 98.39,
    width: 8.59,
    height: 8.59,
    transform: "translate(853.52 205.37) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.08,107h-8.64V98.36h8.64Zm-8.59,0H431V98.41h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 98.39,
    width: 8.59,
    height: 8.59,
    transform: "translate(826.13 205.37) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.39,107h-8.65V98.36h8.65Zm-8.59,0h8.53V98.41H408.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.86,
    y: 85.04,
    width: 8.59,
    height: 8.59,
    transform: "translate(908.31 178.67) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.48,93.66h-8.64V85h8.64Zm-8.59,0h8.54V85.07h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 85.04,
    width: 8.59,
    height: 8.59,
    transform: "translate(880.92 178.67) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.78,93.66h-8.64V85h8.64Zm-8.59,0h8.54V85.07h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.47,
    y: 85.04,
    width: 8.59,
    height: 8.59,
    transform: "translate(853.52 178.67) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.08,93.66h-8.64V85h8.64Zm-8.59,0H431V85.07h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 85.04,
    width: 8.59,
    height: 8.59,
    transform: "translate(826.13 178.67) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.39,93.66h-8.65V85h8.65Zm-8.59,0h8.53V85.07H408.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.86,
    y: 71.69,
    width: 8.59,
    height: 8.59,
    transform: "translate(908.31 151.97) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.48,80.31h-8.64V71.67h8.64Zm-8.59,0h8.54V71.72h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.16,
    y: 71.69,
    width: 8.59,
    height: 8.59,
    transform: "translate(880.92 151.97) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.78,80.31h-8.64V71.67h8.64Zm-8.59,0h8.54V71.72h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.47,
    y: 71.69,
    width: 8.59,
    height: 8.59,
    transform: "translate(853.52 151.97) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.08,80.31h-8.64V71.67h8.64Zm-8.59,0H431V71.72h-8.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 71.69,
    width: 8.59,
    height: 8.59,
    transform: "translate(826.13 151.97) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.39,80.31h-8.65V71.67h8.65Zm-8.59,0h8.53V71.72H408.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,70.37s0,.34,0,1,0,1.58,0,2.78c0,2.45,0,6,.05,10.54,0,9.06.07,22,.12,37.58L466,122l59.94,0h0l-.26.26c0-18.83,0-36.57,0-51.87l.23.23-43.31-.12-12.25-.06-3.25,0H466a1.1,1.1,0,0,1,.26,0h.82l3.21,0,12.19-.06,43.46-.11h.23v.23c0,15.3,0,33,0,51.87v.26h-.26l-59.94,0h-.22v-.22c0-15.64.08-28.62.11-37.72,0-4.51,0-8,.06-10.49,0-1.18,0-2.1,0-2.74S466,70.37,466,70.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.48,76c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S516.33,76,516.48,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.4,76c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S506.26,76,506.4,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.33,76c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S496.18,76,496.33,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.25,76c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S486.11,76,486.25,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.18,76c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S476,76,476.18,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.41,
    cy: 80.37,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.41,81.75a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,516.41,81.75Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,516.41,79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.4,
    cy: 91.11,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.4,92.5a1.39,1.39,0,1,1,1.39-1.39A1.38,1.38,0,0,1,506.4,92.5Zm0-2.72a1.34,1.34,0,1,0,1.34,1.33A1.34,1.34,0,0,0,506.4,89.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.74,
    cy: 100.52,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.74,101.9a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,496.74,101.9Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.33,1.33,0,0,0,496.74,99.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.43,
    cy: 79.69,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.43,81.07a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,486.43,81.07Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,486.43,78.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.18,
    cy: 111.74,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.18,113.12a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,476.18,113.12Zm0-2.72a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,476.18,110.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.27,70.37s0,.34,0,1,0,1.58,0,2.78c0,2.45,0,6,.06,10.54,0,9.06.06,22,.11,37.58l-.22-.22,59.94,0h0l-.26.26c0-18.83,0-36.57,0-51.87l.23.23-43.31-.12-12.25-.06-3.25,0h-1.14a1.39,1.39,0,0,1,.27,0h.81l3.21,0,12.2-.06,43.46-.11h.23v.23c0,15.3,0,33,0,51.87v.26h-.27l-59.94,0h-.22v-.22c0-15.64.09-28.62.12-37.72,0-4.51,0-8,.05-10.49,0-1.18,0-2.1,0-2.74S253.27,70.37,253.27,70.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.77,76c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S303.63,76,303.77,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.7,76c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S293.55,76,293.7,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.62,76c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S283.48,76,283.62,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.55,76c.14,0,.26,9,.26,20s-.12,20-.26,20-.26-9-.26-20S273.41,76,273.55,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.47,76c.15,0,.26,9,.26,20s-.11,20-.26,20-.26-9-.26-20S263.33,76,263.47,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.71,
    cy: 80.37,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71,81.75a1.39,1.39,0,1,1,1.39-1.38A1.39,1.39,0,0,1,303.71,81.75Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,303.71,79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.7,
    cy: 91.11,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.7,92.5a1.39,1.39,0,1,1,1.38-1.39A1.39,1.39,0,0,1,293.7,92.5Zm0-2.72A1.34,1.34,0,1,0,295,91.11,1.34,1.34,0,0,0,293.7,89.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.04,
    cy: 100.52,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,101.9a1.39,1.39,0,1,1,1.38-1.38A1.38,1.38,0,0,1,284,101.9Zm0-2.72a1.34,1.34,0,1,0,1.33,1.34A1.34,1.34,0,0,0,284,99.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.73,
    cy: 79.69,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.73,81.07a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,273.73,81.07Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,273.73,78.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.47,
    cy: 111.74,
    r: 1.36,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.47,113.12a1.39,1.39,0,1,1,1.39-1.38A1.38,1.38,0,0,1,263.47,113.12Zm0-2.72a1.34,1.34,0,1,0,1.34,1.34A1.34,1.34,0,0,0,263.47,110.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.65,
    cy: 114.65,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,114.65a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,380,114.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.17,
    cy: 114.65,
    r: 1.38,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.92,
    cy: 114.65,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,114.65a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,352.29,114.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.43,
    cy: 114.65,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.19,
    cy: 114.65,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.95,
    cy: 114.65,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.65,
    cy: 105.81,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,105.81a1.39,1.39,0,1,1,1.39,1.39A1.38,1.38,0,0,1,380,105.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.17,
    cy: 105.81,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.92,
    cy: 105.81,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,105.81a1.39,1.39,0,1,1,1.39,1.39A1.38,1.38,0,0,1,352.29,105.81Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.43,
    cy: 105.81,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.19,
    cy: 105.81,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.95,
    cy: 105.81,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.65,
    cy: 96.98,
    r: 1.38,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,97a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,380,97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.17,
    cy: 96.98,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.92,
    cy: 96.98,
    r: 1.38,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,97a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,352.29,97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.43,
    cy: 96.98,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.19,
    cy: 96.98,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.95,
    cy: 96.98,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.27,88.14a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,389.27,88.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,88.14a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,380,88.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.78,88.14a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,370.78,88.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.54,88.14a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,361.54,88.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,88.14a1.39,1.39,0,1,1,1.39,1.38A1.39,1.39,0,0,1,352.29,88.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.05,88.14a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,343.05,88.14Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.81,88.14a1.39,1.39,0,1,1,1.38,1.38A1.38,1.38,0,0,1,333.81,88.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.56,88.14A1.39,1.39,0,1,1,326,89.52,1.39,1.39,0,0,1,324.56,88.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.27,79.3a1.39,1.39,0,1,1,1.38,1.39A1.38,1.38,0,0,1,389.27,79.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,79.3a1.39,1.39,0,1,1,1.39,1.39A1.38,1.38,0,0,1,380,79.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.78,79.3a1.39,1.39,0,1,1,1.39,1.39A1.38,1.38,0,0,1,370.78,79.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.54,79.3a1.39,1.39,0,1,1,1.38,1.39A1.38,1.38,0,0,1,361.54,79.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,79.3a1.39,1.39,0,1,1,1.39,1.39A1.38,1.38,0,0,1,352.29,79.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.05,79.3a1.39,1.39,0,1,1,1.38,1.39A1.38,1.38,0,0,1,343.05,79.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.81,79.3a1.39,1.39,0,1,1,1.38,1.39A1.38,1.38,0,0,1,333.81,79.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.56,79.3A1.39,1.39,0,1,1,326,80.69,1.38,1.38,0,0,1,324.56,79.3Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.68,
    y: 114.65,
    width: 7.59,
    height: 7.59,
    transform: "translate(488.94 236.89) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.29,122.26h-7.64v-7.64h7.64Zm-7.59-.05h7.54v-7.54H240.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.68,
    y: 104.22,
    width: 7.59,
    height: 7.59,
    transform: "translate(488.94 216.04) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.29,111.84h-7.64V104.2h7.64Zm-7.59,0h7.54v-7.54H240.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.68,
    y: 93.8,
    width: 7.59,
    height: 7.59,
    transform: "translate(488.94 195.19) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.29,101.42h-7.64V93.77h7.64Zm-7.59,0h7.54V93.82H240.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.68,
    y: 83.38,
    width: 7.59,
    height: 7.59,
    transform: "translate(488.94 174.34) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.29,91h-7.64V83.35h7.64Zm-7.59,0h7.54V83.4H240.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.68,
    y: 72.95,
    width: 7.59,
    height: 7.59,
    transform: "translate(488.94 153.49) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.29,80.57h-7.64V72.93h7.64Zm-7.59,0h7.54V73H240.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.82,
    y: 71.14,
    width: 44.01,
    height: 51.1,
    transform: "translate(427.65 193.38) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.85,122.26h-44V71.11h44Zm-44-.05h44v-51h-44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.42 319.9 179.48 288.45 569 288.45 583.72 319.9 163.42 319.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.69,314.26c-.29,0-1.3-4.4-2.27-9.94s-1.52-10.06-1.24-10.11,1.3,4.4,2.27,9.93S312,314.21,311.69,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.29,291.07a4,4,0,0,1,.47,0l1.45,0,5.69,0,22-.08,81.57-.16,273.82-.19h.33l.14.3,11.87,25.58.35.74H565.16c-182,0-337.36-.14-397.35-.34h-.31l.15-.27,10.18-19.11,2.58-4.8.65-1.19c.15-.27.23-.39.23-.39l-.2.43c-.15.28-.35.69-.63,1.23L178,297.6c-2.24,4.29-5.57,10.69-10,19.14l-.17-.28c60-.19,215.33-.33,397.35-.33h13l-.47.74-11.87-25.58.47.3-273.55-.2-81.65-.15-22.1-.09-5.74,0-1.47,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.89,
    y1: 293.1,
    x2: 190.75,
    y2: 314.26,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.75,314.26c-.27-.12,1.56-4.95,4.09-10.79s4.78-10.48,5-10.37-1.57,4.94-4.1,10.79S191,314.37,190.75,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.11,304.84a2.54,2.54,0,1,1,0-3.59A2.54,2.54,0,0,1,197.11,304.84Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.71,314.26c-.28-.08.77-4.88,2.33-10.72s3.06-10.51,3.34-10.44-.77,4.87-2.33,10.71S203,314.33,202.71,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.47,314.26c-.28-.07.51-4.85,1.77-10.69S216.75,293,217,293.1s-.52,4.85-1.78,10.69S212.75,314.32,212.47,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.74,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.26,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.72,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.19,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.32,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.74,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.26,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.72,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.19,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.32,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.01,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.52,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.99,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.45,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.38,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.84,
    y: 302.1,
    width: 4.27,
    height: 4.27,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.31,314.26c-.29,0-1.3-4.4-2.27-9.94s-1.52-10.06-1.24-10.11,1.3,4.4,2.27,9.93S279.59,314.21,279.31,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.4,314.26c-.28,0-1.3-4.4-2.27-9.94s-1.52-10.06-1.24-10.11,1.3,4.4,2.27,9.93S287.68,314.21,287.4,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.5,314.26c-.29,0-1.3-4.4-2.27-9.94s-1.52-10.06-1.24-10.11,1.3,4.4,2.27,9.93S295.78,314.21,295.5,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.59,314.26c-.28,0-1.3-4.4-2.27-9.94s-1.52-10.06-1.24-10.11,1.3,4.4,2.27,9.93S303.87,314.21,303.59,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.78,314.26c-.28,0-1.3-4.4-2.27-9.94s-1.52-10.06-1.24-10.11,1.3,4.4,2.27,9.93S320.06,314.21,319.78,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.23,312.58a2.54,2.54,0,1,1,0-3.59A2.52,2.52,0,0,1,205.23,312.58Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.15,
    cy: 297.21,
    r: 2.54,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.59,299.63a2.54,2.54,0,1,1,0-3.59A2.52,2.52,0,0,1,277.59,299.63Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.42,307.08a2.55,2.55,0,1,1,0-3.6A2.55,2.55,0,0,1,287.42,307.08Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.22,311.26a2.54,2.54,0,1,1,0-3.59A2.52,2.52,0,0,1,296.22,311.26Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.3,300.17a2.54,2.54,0,1,1,0-3.59A2.54,2.54,0,0,1,302.3,300.17Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.32,312a2.54,2.54,0,1,1,0-3.59A2.54,2.54,0,0,1,312.32,312Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.88,300.62a2.54,2.54,0,1,1,0-3.59A2.52,2.52,0,0,1,318.88,300.62Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 548.76,
    y1: 293.1,
    x2: 557.9,
    y2: 314.26,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.9,314.25c-.26.12-2.52-4.52-5-10.36s-4.35-10.67-4.09-10.79,2.52,4.53,5,10.37S558.16,314.14,557.9,314.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.33,
    cy: 303.05,
    r: 2.54,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.94,314.26c-.28.07-1.78-4.61-3.34-10.45s-2.61-10.63-2.33-10.71,1.77,4.6,3.34,10.44S546.21,314.18,545.94,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.18,314.26c-.29.06-1.54-4.63-2.8-10.47s-2-10.63-1.77-10.69,1.53,4.63,2.79,10.47S536.46,314.19,536.18,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.63,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    transform: "translate(1043.54 592.69) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.12,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    transform: "translate(1024.51 592.69) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.66,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    transform: "translate(1005.58 592.69) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.19,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    transform: "translate(986.65 592.69) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.06,
    y: 294.21,
    width: 4.27,
    height: 4.27,
    transform: "translate(966.38 592.69) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.63,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    transform: "translate(1043.54 621.58) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.12,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    transform: "translate(1024.51 621.58) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.66,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    transform: "translate(1005.58 621.58) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.19,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    transform: "translate(986.65 621.58) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.06,
    y: 308.66,
    width: 4.27,
    height: 4.27,
    transform: "translate(966.38 621.58) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.37,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    transform: "translate(1051 608.35) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 513.86,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    transform: "translate(1031.98 608.35) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.39,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    transform: "translate(1013.05 608.35) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.92,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    transform: "translate(994.12 608.35) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476,
    y: 302.04,
    width: 4.27,
    height: 4.27,
    transform: "translate(956.26 608.35) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.54,
    y: 302.1,
    width: 4.27,
    height: 4.27,
    transform: "translate(973.35 608.47) rotate(180)",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.34,314.26c-.28-.05.27-4.58,1.24-10.12s2-10,2.27-9.93-.27,4.58-1.24,10.11S469.62,314.3,469.34,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.25,314.26c-.29-.05.27-4.58,1.24-10.12s2-10,2.26-9.93-.27,4.58-1.24,10.11S461.53,314.3,461.25,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.15,314.26c-.28-.05.27-4.58,1.24-10.12s2-10,2.27-9.93-.27,4.58-1.24,10.11S453.43,314.3,453.15,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.06,314.26c-.29-.05.27-4.58,1.24-10.12s2-10,2.26-9.93-.27,4.58-1.24,10.11S445.34,314.3,445.06,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.87,314.26c-.29-.05.27-4.58,1.24-10.12s2-10,2.26-9.93-.27,4.58-1.24,10.11S429.15,314.3,428.87,314.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.41,312.58a2.54,2.54,0,1,0,0-3.59A2.52,2.52,0,0,0,543.41,312.58Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532.5,
    cy: 297.21,
    r: 2.54,
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.05,299.63a2.54,2.54,0,1,0,0-3.59A2.52,2.52,0,0,0,471.05,299.63Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.23,307.08a2.54,2.54,0,1,0,0-3.6A2.54,2.54,0,0,0,461.23,307.08Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.42,311.26a2.54,2.54,0,1,0,0-3.59A2.54,2.54,0,0,0,452.42,311.26Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.35,300.17a2.54,2.54,0,1,0,0-3.59A2.54,2.54,0,0,0,446.35,300.17Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.33,312a2.54,2.54,0,1,0,0-3.59A2.54,2.54,0,0,0,436.33,312Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.77,300.62a2.54,2.54,0,1,0,0-3.59A2.52,2.52,0,0,0,429.77,300.62Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "179.48 337.83 179.48 466.12 195.32 466.12 195.32 337.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "553.43 337.83 553.43 466.12 569.27 466.12 569.27 337.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.34,335.42s0,.09-.1.26l-.31.75-.53,1.21a13.9,13.9,0,0,1-.79,1.62,44,44,0,0,1-6.58,9.42c-.77.94-1.73,1.79-2.66,2.73s-2,1.79-3.13,2.72-2.3,1.79-3.61,2.58c-.65.4-1.29.84-2,1.24l-2.09,1.14a45.11,45.11,0,0,1-40.43,1l-2.14-1c-.7-.37-1.36-.77-2-1.15-1.34-.72-2.53-1.62-3.73-2.39S217,353.82,216,353s-2-1.7-2.79-2.6a43.84,43.84,0,0,1-7-9.08,13.79,13.79,0,0,1-.87-1.58l-.59-1.19c-.15-.3-.26-.54-.35-.73a1,1,0,0,1-.11-.26,1.23,1.23,0,0,1,.15.24l.4.7.63,1.16a15.31,15.31,0,0,0,.91,1.55,46.32,46.32,0,0,0,7.11,8.93c.83.89,1.83,1.67,2.8,2.55s2.12,1.66,3.25,2.51,2.37,1.65,3.72,2.36c.66.36,1.31.76,2,1.12l2.13,1a47.16,47.16,0,0,0,9.46,3.19,42.8,42.8,0,0,0,21.25-.52,47.17,47.17,0,0,0,9.29-3.65l2.08-1.13c.67-.39,1.31-.82,1.95-1.22,1.3-.77,2.43-1.71,3.59-2.53s2.17-1.77,3.12-2.67,1.9-1.76,2.67-2.69a45.79,45.79,0,0,0,6.67-9.26,15.57,15.57,0,0,0,.83-1.6l.57-1.18.37-.73C289.28,335.5,289.33,335.41,289.34,335.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.27,334.63a1.48,1.48,0,0,1-.08.3l-.28.84-.47,1.38a14.5,14.5,0,0,1-.74,1.85l-1,2.26c-.41.82-.93,1.67-1.44,2.6a32.61,32.61,0,0,1-1.85,2.86,36.5,36.5,0,0,1-2.31,3c-.81,1.07-1.84,2-2.82,3.12-.49.55-1.07,1-1.63,1.54s-1.12,1-1.73,1.55L520,357.44c-.33.25-.64.52-1,.75l-1,.69c-.71.46-1.4.95-2.14,1.4l-2.3,1.29c-.76.46-1.59.79-2.41,1.18a26.09,26.09,0,0,1-2.53,1.1l-2.64,1-2.76.78a42.05,42.05,0,0,1-23.6-.56l-2.72-.91L474.29,363a25.86,25.86,0,0,1-2.48-1.21,23.16,23.16,0,0,1-2.35-1.3l-2.23-1.39c-.72-.48-1.39-1-2.07-1.5l-1-.74c-.33-.25-.63-.53-.94-.79l-1.83-1.57c-.58-.53-1.11-1.09-1.65-1.63s-1.09-1-1.55-1.61c-.93-1.13-1.92-2.14-2.67-3.25a37.17,37.17,0,0,1-2.17-3.15,30.74,30.74,0,0,1-1.71-2.94c-.47-1-.94-1.83-1.31-2.66l-.93-2.31a13.52,13.52,0,0,1-.64-1.88c-.16-.55-.3-1-.41-1.4s-.18-.64-.25-.86a1.18,1.18,0,0,1-.06-.3,1.2,1.2,0,0,1,.12.28c.07.22.17.5.29.85s.28.84.45,1.38a15.11,15.11,0,0,0,.69,1.85l1,2.29c.38.82.87,1.68,1.35,2.62a33,33,0,0,0,1.73,2.9,36.83,36.83,0,0,0,2.18,3.1c.76,1.1,1.74,2.1,2.68,3.21.45.56,1,1.05,1.54,1.59s1.07,1.08,1.65,1.6l1.82,1.55c.31.25.61.53.94.78l1,.73c.68.48,1.35,1,2.06,1.47l2.21,1.37a25,25,0,0,0,2.34,1.28c.8.4,1.59.86,2.45,1.19l2.56,1.09,2.7.89a41.67,41.67,0,0,0,23.32.55l2.74-.76,2.61-1a51.55,51.55,0,0,0,4.9-2.24l2.28-1.26c.73-.44,1.42-.92,2.12-1.37l1-.68c.33-.24.65-.5,1-.74l1.89-1.45c.6-.5,1.16-1,1.72-1.53a19.62,19.62,0,0,0,1.62-1.52,41.4,41.4,0,0,0,2.82-3.07,34.82,34.82,0,0,0,2.33-3c.67-1,1.37-1.89,1.87-2.82s1-1.76,1.47-2.56.74-1.56,1.07-2.23a14.83,14.83,0,0,0,.77-1.82c.2-.53.38-1,.52-1.36s.25-.62.33-.83A1.47,1.47,0,0,1,536.27,334.63Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "380.39 458.37 377.94 466.55 395.43 466.34 396.21 457.59 380.39 458.37",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.77,464.68a10.56,10.56,0,0,1-2.55.2c-1.57.05-3.75,0-6.15,0l-6.14-.19a12.84,12.84,0,0,1-2.54-.2,10.51,10.51,0,0,1,2.54-.2c1.58,0,3.75,0,6.15,0l6.14.19A12.64,12.64,0,0,1,395.77,464.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.27,457.26a12.75,12.75,0,0,1,.07,3.69,12.55,12.55,0,0,1-.48,3.66,12.34,12.34,0,0,1-.07-3.69A12.09,12.09,0,0,1,388.27,457.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "377.94 466.55 395.43 466.34 395.58 464.69 378.23 464.46 377.94 466.35",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434,461.56l0-9.9-18.55-.07-.11,14.49,1.15.07c5.12.31,26,1.18,29.46.16C449.74,465.17,434,461.56,434,461.56Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.69,463.6s5.52,1.61,4.83,2.52-21.87.81-31.21,0l0-.42L440,466S440.61,463.64,441.69,463.6Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.05,465.65a1.34,1.34,0,0,0,.32,0l.91.06,3.37.16c2.85.12,6.79.22,11.13.25s8.29,0,11.14-.13l3.37-.13.91-.05.32,0-.32,0h-.92l-3.37.06c-2.85,0-6.78.08-11.13.06s-8.27-.1-11.12-.18l-3.37-.08-.92,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,466.27a7.72,7.72,0,0,1,.64-1.61,7.43,7.43,0,0,1,1.16-1.29,3,3,0,0,0-1.8,2.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.57,463.47c.06,0,.32-.29.59-.71s.45-.8.4-.83-.32.28-.59.71S434.52,463.43,434.57,463.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.07,462.67c.05,0,.34-.15.66-.44s.55-.55.51-.6-.34.15-.66.43S433,462.62,433.07,462.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.13,460.91a2.27,2.27,0,0,0,1,.13,2.15,2.15,0,0,0,1-.1,2.23,2.23,0,0,0-1-.13A2.36,2.36,0,0,0,432.13,460.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.81,459.67a1.78,1.78,0,0,0,1.08.32,1.83,1.83,0,0,0,1.12-.14,6.47,6.47,0,0,0-1.1-.08A6,6,0,0,0,431.81,459.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.21,461.85a3.41,3.41,0,0,0,1.19,0,6.55,6.55,0,0,0,1.27-.28,3.57,3.57,0,0,0,.73-.29.66.66,0,0,0,.3-.37.48.48,0,0,0-.18-.48,2.21,2.21,0,0,0-3.1,1.42c-.05.21-.05.32,0,.32a3.43,3.43,0,0,1,.54-1,2.14,2.14,0,0,1,1-.66,1.85,1.85,0,0,1,1.42.11c.18.14.11.36-.1.48a3.31,3.31,0,0,1-.67.29,8.51,8.51,0,0,1-1.23.31C435.66,461.81,435.21,461.81,435.21,461.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.52,461.91a1.26,1.26,0,0,0,.14-.83,2,2,0,0,0-.32-.87,1.21,1.21,0,0,0-1-.61.47.47,0,0,0-.37.55,1.2,1.2,0,0,0,.2.53,3.41,3.41,0,0,0,.56.73,1.72,1.72,0,0,0,.68.48s-.24-.21-.57-.59a4.48,4.48,0,0,1-.49-.72c-.16-.25-.27-.71,0-.76s.61.27.79.51a2,2,0,0,1,.33.78A4.5,4.5,0,0,1,435.52,461.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.45,460.58s.53-.05,1.37.05a5.8,5.8,0,0,1,4.84,3.89c.28.8.31,1.33.35,1.33a1.25,1.25,0,0,0,0-.38,4.69,4.69,0,0,0-.2-1,5.66,5.66,0,0,0-5-4,5.44,5.44,0,0,0-1,0C415.58,460.53,415.45,460.56,415.45,460.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.4,452.87a32.15,32.15,0,0,0-.17,3.8,29.33,29.33,0,0,0,0,3.82,32.6,32.6,0,0,0,.17-3.81A29.13,29.13,0,0,0,417.4,452.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.38,464.16a11,11,0,0,0,2.7.28,10.56,10.56,0,0,0,2.72-.21c0-.06-1.22,0-2.71,0S424.38,464.09,424.38,464.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.74,464.14s.1.25.22.53.19.53.25.52.1-.29,0-.61S420.78,464.09,420.74,464.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.38,462.43c-.05,0,.07.23.26.43s.39.32.43.27-.07-.23-.27-.43S419.42,462.38,419.38,462.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.42,461.64c0,.06.26.06.53.16s.47.24.52.2-.11-.3-.44-.42S417.4,461.58,417.42,461.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,461.26c0,.06.08.16.24.22s.29.06.31,0-.08-.15-.23-.21S416.05,461.21,416,461.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "415.31 460.08 434.01 459.85 433.98 456.34 415.38 456.57 415.31 460.08"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M391.09,337.83l32.44,6.27a18.83,18.83,0,0,1,15.27,18.5l0,94.45h-26.7l0-90.49H392.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.44 459.66 374.3 459.01 371.14 345.14 403 345.14 399.44 459.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.57,291.07s-7.55,23.15-7.14,25.8,4,10.91,7.14,9.88,12.59-6.84,13.77-11,6.18-21.66,6.18-21.66Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.35,294.09l7.42,22.36c2,6,7.29,7.07,13.65,7.07h41.31v-9.26L429,308.87l-9-23Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.28,312.33l3.27-1.55s3.54-6.83,4.35-6.56,1.05,2.29-.37,5.42l4.35-1.24s9.44,4.36,9,5a2.18,2.18,0,0,1-3.25.93c-2.06-1-4.75-2.29-4.75-2.29l-5.09,1.45,6.56.84,6.17,5.61a3,3,0,0,1-3.77-.09l-16,3.44-5,.28v-9.26Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.78,319.8c-.07,0-.37-.43-.95-1.06a4.86,4.86,0,0,0-1.16-.9,4.63,4.63,0,0,0-1.73-.45,23.62,23.62,0,0,1-4.81-.83,24.56,24.56,0,0,1,4.87.33,4.66,4.66,0,0,1,1.9.55,4.39,4.39,0,0,1,1.2,1.07A2.91,2.91,0,0,1,487.78,319.8Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.27,320.44c-.06,0-.11-.33-.56-.43s-1.19-.17-1.95-.25a15.72,15.72,0,0,1-2.81-.28,5.68,5.68,0,0,1,2.86-.21,8.24,8.24,0,0,1,2,.41.84.84,0,0,1,.49.5C485.36,320.36,485.3,320.45,485.27,320.44Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.23,247.57s-25.4-4.25-33.45,22.54l-5.55,20.68,22.39,4.28v52H406l-1.29-51.84L423,286.66s-10.22-41.78-37.23-39.17Z",
    style: {
      fill: "#FF9F00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.68,
    y: 371.22,
    width: 8.08,
    height: 86.42,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.05,371.22H342.66c0-6.93-2.81-12.55,4.12-12.55H404.5a12.55,12.55,0,0,1,12.55,12.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.08,466.12h-1.15a34.39,34.39,0,1,0-68.78,0H341a35.54,35.54,0,1,1,71.08,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.9,467.89a5.33,5.33,0,1,1-5.33-5.33A5.33,5.33,0,0,1,346.9,467.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.1,467.15a5.33,5.33,0,1,1-5.33-5.33A5.33,5.33,0,0,1,417.1,467.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.73,457.35c0,.16-15.46.3-34.53.3s-34.54-.14-34.54-.3,15.46-.3,34.54-.3S411.73,457.18,411.73,457.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.65,276.31V347.6a16.93,16.93,0,0,0,16.93,16.93h36.33a17.26,17.26,0,0,0,17.26-17.26V274.89a6.13,6.13,0,0,0-6.13-6.13H346.19A7.55,7.55,0,0,0,338.65,276.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.8,371.22c0,.14-16.74.26-37.4.26s-37.4-.12-37.4-.26,16.74-.26,37.4-.26S415.8,371.08,415.8,371.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,358.67c0,.15-12.58.26-28.11.26s-28.11-.11-28.11-.26,12.59-.26,28.11-.26S403,358.53,403,358.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.47,202.13l-2.24,45.44,19.45,1.83,1.08-11s6.86,1.69,8.94-4.66c1.34-4.05,2.52-35.82,2.52-35.82Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.9,203.21c.54,4.25-5.41,6.71-5.41,6.71l-1,10.06a19.91,19.91,0,0,0-2.79,0c.5-4.72-5.58-3.8-6.2-.58s2.93,5.16,2.93,5.16c-2.43,3.73-3.42,5.7-6.87,9.2-3.74,3.79-5.75,4.09-9.6,4l-4.25-.2s-1.52-3.63-2.63-12.21c-.53-4.12-3.75-9.53-2.83-16.24,2.6-19.06,20.87-17,20.87-17C392.55,192.29,399.65,193.34,400.9,203.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.76,209.61a14.39,14.39,0,0,0,9.21-9.83,7,7,0,0,0-.34-5.27c-.9-1.57-3-2.51-4.61-1.64a5.28,5.28,0,0,0-10.26-1.75,4.73,4.73,0,0,0-5.24-1.47,6.73,6.73,0,0,0-3.93,4,11.78,11.78,0,0,0-.48,5.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,196.76c0-.06.33-.22.95-.27a5,5,0,0,1,2.37.41,5.15,5.15,0,0,1,1.92,1.44c.38.49.5.86.45.89a7.42,7.42,0,0,0-5.69-2.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.92,194.57c.14.06-.23,1,.08,2.06s1.05,1.71,1,1.83-.3,0-.62-.29a2.95,2.95,0,0,1-.82-3C365.68,194.73,365.86,194.54,365.92,194.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.39,214.56l-.15.13a4.06,4.06,0,0,1-.49.35,5.57,5.57,0,0,1-2.16.77,11,11,0,0,1-7.91-2.48,7.4,7.4,0,0,1-1.92-2.08,4,4,0,0,1-.52-3,2.84,2.84,0,0,1,5.37-.88,4.36,4.36,0,0,1,.29,3.67,8.38,8.38,0,0,1-2,3.24A9.15,9.15,0,0,1,378.5,217a9.32,9.32,0,0,1-3.88-1.24,7.3,7.3,0,0,1-2.81-2.81,4.13,4.13,0,0,1-.25-3.83,3.45,3.45,0,0,1,3.22-1.79,2.29,2.29,0,0,1,1.64.9,3.07,3.07,0,0,1,.57,1.7,6.25,6.25,0,0,1-.82,3.2,7.88,7.88,0,0,1-4.5,3.67,7,7,0,0,1-4.78-.22,7.62,7.62,0,0,1-2.95-2.12,6.52,6.52,0,0,1-1.2-1.95,3.72,3.72,0,0,1-.19-.57c0-.13-.05-.19,0-.19a9,9,0,0,0,1.58,2.58,7.7,7.7,0,0,0,2.9,2,6.69,6.69,0,0,0,4.57.14,7.55,7.55,0,0,0,4.23-3.52,5.86,5.86,0,0,0,.75-3,2.67,2.67,0,0,0-.5-1.45,1.79,1.79,0,0,0-1.31-.7A3,3,0,0,0,372,209.3a3.69,3.69,0,0,0,.25,3.36,8.12,8.12,0,0,0,6.3,3.78,8.71,8.71,0,0,0,6.95-2.56,7.73,7.73,0,0,0,1.93-3,3.9,3.9,0,0,0-.23-3.27,2.63,2.63,0,0,0-2.63-1.34,2.66,2.66,0,0,0-1.91,2.07,3.62,3.62,0,0,0,.44,2.74,7.22,7.22,0,0,0,1.81,2,10.93,10.93,0,0,0,7.65,2.57A6.91,6.91,0,0,0,395.39,214.56Z",
    style: {
      fill: "#455a64"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.d0d90b186a4672aa6b5c65b0aaa314f1.svg";
export { ForwardRef as ReactComponent };